<template>
  <div>
    <Assistant_teacher_bar />
    <!-- Dashboard Header -->
    <v-container fluid class="pa-0">
      <div class="dashboard-header">
        <v-row class="ma-0">
          <v-col cols="12" class="text-center py-8">
            <h1 class="font-weight-bold white--text mb-4">
              รายงานสรุปผลคะแนนการประเมิน ตำแหน่งครูผู้ช่วย
            </h1>
            <p class="white--text opacity-80">
              ระบบติดตามและประเมินผลการปฏิบัติงานครูผู้ช่วย ครั้งที่ 1 - 4
            </p>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-container fluid class="main-content">
      <!-- Statistics Cards -->
      <v-row class="mb-6">
        <v-col
          cols="12"
          md="3"
          v-for="(stat, index) in statisticsCards"
          :key="index"
        >
          <v-card class="stat-card elevation-3" :class="stat.color" hover>
            <v-card-text class="text-center py-6">
              <v-icon :color="stat.iconColor" size="48" class="mb-3">
                {{ stat.icon }}
              </v-icon>
              <div class="stat-number font-weight-bold mb-2">
                {{ stat.value }}
              </div>
              <div class="stat-label font-weight-medium">
                {{ stat.label }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Filters Section -->
      <base-material-card
        icon="mdi-filter-variant"
        title="เครื่องมือค้นหาและกรอง"
        class="filter-card elevation-3 mb-6"
      >
        <v-card class="filter-content" outlined>
          <v-row no-gutters>
            <v-col cols="12" md="4" class="pa-3">
              <v-autocomplete
                outlined
                dense
                label="ค้นหา วิทยาลัย"
                :items="colleges"
                item-text="college_name"
                item-value="college_code"
                v-model="college_select"
                @change="assistant_teacher_reportCollegeQueryAll()"
                prepend-inner-icon="mdi-school"
                hide-details
                class="custom-input"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="pa-3">
              <v-autocomplete
                outlined
                dense
                label="วันเดือนปีที่บรรจุ"
                :items="groupDateTimeApps"
                item-text="dateApps"
                item-value="dateApps"
                @change="personnel_temporaryDateApp()"
                v-model="dateTimeAppSelect"
                prepend-inner-icon="mdi-calendar"
                hide-details
                class="custom-input"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="pa-3 d-flex align-center justify-end"
            >
              <v-btn
                fab
                outlined
                class="mr-2 custom-btn"
                color="primary"
                :href="'#/admin/print_AssismentReportCP/'"
                target="_blank"
                elevation="2"
              >
                <v-icon>mdi-printer</v-icon>
              </v-btn>

              <v-btn
                fab
                outlined
                :href="
                  '#/admin/print_AssismentReportCPDay2/?mt_appoin_day=' +
                    mt_appoin_day +
                    '&mt_appoin_month=' +
                    mt_appoin_month +
                    '&mt_appoin_year=' +
                    mt_appoin_year +
                    '&mt_type_personnel=' +
                    (mt_type_personnel || 0) +
                    '&mt_admissions_status=' +
                    (mt_admissions_status || 0)
                "
                target="_blank"
                color="info"
                class="mr-2 custom-btn"
                v-if="check_param_query > 1"
                elevation="2"
              >
                <v-icon>mdi-printer-search</v-icon>
              </v-btn>

              <v-btn
                fab
                color="primary"
                @click="checkappoint()"
                class="custom-btn"
                elevation="2"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </base-material-card>

      <!-- Alert Section -->
      <div class="text-center ma-4" v-if="check_CC.counts > 0">
        <v-alert
          type="warning"
          prominent
          border="left"
          colored-border
          class="alert-custom"
        >
          <v-row align="center">
            <v-col class="grow">
              <div class="title font-weight-bold">
                ยกเลิกไฟล์สรุปวันลา: {{ check_CC.counts }} รายการ
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn @click="ccSearch()" color="error" large class="custom-btn">
                <v-icon left>mdi-alert</v-icon>
                ดูรายละเอียด
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </div>
    </v-container>

    <!-- Loading Overlay -->
    <v-overlay :value="loading" z-index="9999">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      top
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      elevation="6"
    >
      <v-icon large class="mr-3">{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="รายงานสรุปผลคะแนนการประเมิน ตำแหน่งครูผู้ช่วย ครั้งที่ 1 - 4"
        class="table-card elevation-3"
      >
        <!-- เครื่องมืออนุมัติ คศ.1 -->
        <v-card elevation="0" outlined class="atl1-toolbar pa-3 mb-2">
          <div class="d-flex flex-wrap align-center">
            <div class="subtitle-1 font-weight-bold mr-3">
              <v-icon color="success" class="mr-1">mdi-account-tie</v-icon>
              อนุมัติให้ดำรงตำแหน่งครู คศ.1
            </div>
            <v-progress-circular
              v-if="atl1Loading"
              indeterminate
              size="20"
              width="2"
              color="primary"
              class="mr-2"
            ></v-progress-circular>
            <v-btn-toggle
              v-model="atl1Filter"
              mandatory
              dense
              rounded
              class="mr-2 my-1"
            >
              <v-btn small value="all">ทั้งหมด ({{ tableItemsAll.length }})</v-btn>
              <v-btn small value="eligible" class="success--text">
                <v-icon small left color="success">mdi-check-decagram</v-icon>
                พร้อมอนุมัติ ({{ atl1Counts.eligible }})
              </v-btn>
              <v-btn small value="blocked" class="error--text">
                <v-icon small left color="error">mdi-close-octagon</v-icon>
                ไม่ผ่านเงื่อนไข ({{ atl1Counts.blocked }})
              </v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <v-btn small text color="primary" class="my-1" @click="helpDialog = true">
              <v-icon left>mdi-help-circle-outline</v-icon> คู่มือการใช้งาน
            </v-btn>
          </div>

          <div class="d-flex flex-wrap align-center mt-1">
            <span class="caption mr-2">กรองตามเงื่อนไขที่ไม่ผ่าน:</span>
            <v-chip
              v-for="c in atl1CheckDefs"
              :key="c.key"
              small
              class="mr-1 my-1"
              :outlined="atl1CheckFilter !== c.key"
              :color="atl1CheckFilter === c.key ? 'error' : 'grey darken-1'"
              :dark="atl1CheckFilter === c.key"
              @click="toggleCheckFilter(c.key)"
            >
              <v-icon x-small left>{{ c.icon }}</v-icon>
              {{ c.label }} ({{ atl1Counts.byCheck[c.key] || 0 }})
            </v-chip>
          </div>

          <v-divider class="my-2"></v-divider>

          <div class="d-flex flex-wrap align-center">
            <v-btn
              small
              outlined
              color="success"
              class="mr-2 my-1"
              :disabled="eligibleInView.length === 0"
              @click="selectAllEligible()"
            >
              <v-icon left small>mdi-checkbox-multiple-marked</v-icon>
              เลือกทุกคนที่พร้อมอนุมัติ ({{ eligibleInView.length }})
            </v-btn>
            <v-btn
              small
              text
              class="mr-2 my-1"
              :disabled="selected.length === 0"
              @click="selected = []"
            >
              ล้างที่เลือก
            </v-btn>
            <v-btn
              color="success"
              class="mr-2 my-1"
              :disabled="selected.length === 0"
              @click="openApproveDialog()"
            >
              <v-icon left>mdi-account-check</v-icon>
              อนุมัติที่เลือก ({{ selected.length }} ราย)
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn small outlined color="primary" class="mr-2 my-1" @click="importCsvDialog = true">
              <v-icon left small>mdi-file-upload</v-icon> นำเข้า CSV
            </v-btn>
            <v-btn small outlined color="primary" class="mr-2 my-1" @click="exportEligibilityCsv()">
              <v-icon left small>mdi-file-download</v-icon> ส่งออกรายชื่อ
            </v-btn>
            <v-btn small outlined color="grey darken-2" class="my-1" @click="openHistory()">
              <v-icon left small>mdi-history</v-icon> ประวัติการอนุมัติ
            </v-btn>
          </div>
        </v-card>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="tableItems"
          item-key="atl1Key"
          show-select
          selectable-key="atl1Selectable"
          class="custom-table elevation-0"
          :loading="loading"
          :search="search"
          :items-per-page="25"
          loading-text="กำลังโหลดข้อมูล..."
          no-data-text="ไม่พบข้อมูล"
        >
          <template v-slot:top>
            <div class="search-section pa-4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                filled
                dense
                hide-details
                class="search-input mb-4"
                clearable
              />

              <v-radio-group row class="search-options">
                <v-radio
                  label="ชื่อ"
                  value="radio-1"
                  @click.native="search_name()"
                  color="primary"
                ></v-radio>
                <v-radio
                  label="นามสกุล"
                  value="radio-2"
                  @click.native="search_lastname()"
                  color="primary"
                ></v-radio>
                <v-radio
                  label="รหัสบัตรประชาชน"
                  value="radio-3"
                  @click.native="search_idcard()"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </div>
          </template>

          <template v-slot:item.LoginAdmin="{ item }">
            <v-icon
              v-if="user_id.userauthorityAdmin === '1' || user_id.userauthorityAdmin === 1"
              color="info"
              @click="userLogin(item.user_name, item.user_password)"
            >
              mdi-puzzle
            </v-icon>
          </template>

          <template v-slot:item.mt_type_personnel="{ item }">
            <div v-if="item.mt_type_personnel === 'local_dev'">
              <v-chip color="info" dark>ครูพัฒนาท้องถิ่น</v-chip>
            </div>
            <div v-else-if="item.mt_type_personnel === 'transfer_position'">
              <v-chip color="warning" dark>ครูโอนย้าย</v-chip>
            </div>
            <div v-else>
              <v-chip color="success" dark>ปกติ</v-chip>
            </div>
          </template>

          <template v-slot:item.pt_licence="{ item }">
            <div v-if="item.mt_license_status === 'have' || item.mt_license_status === 'Have' || item.mt_license_status === 'HAVE' ">
              <v-icon color="info" size="30"
                >mdi-card-account-details-star</v-icon
              >
            </div>

            <div v-else-if="item.mt_license_status === 'donot'">
              (P License)
              <v-icon color="warning" size="30">mdi-card-bulleted-off</v-icon>

              <div v-if="item.pt_licence_tem">
                <div v-if="String(item.pt_licence_file_tem).length < 10">
                  <v-chip color="error" outlined>
                    <v-icon>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                  </v-chip>
                </div>
                <div v-else>
                  <v-chip
                    @click="viewpdflicenseteach(item.pt_licence_file_tem)"
                    outlined
                    color="info"
                  >
                    <v-icon>mdi-magnify</v-icon>
                    {{ item.pt_licence_tem }}</v-chip
                  >
                </div>
                หมดอายุวันที่ <br />
                {{
                  item.pt_enddate_tem
                    | moment("add", "543 year")
                    | moment("D MMMM YYYY")
                }}
                <div
                  v-if="item.datediffendtem <= 0"
                  class="error--text font-weight-bold"
                >
                  <v-icon color="error" size="30">mdi-alert</v-icon>
                  <br />
                  หมดก่อน {{ item.datediffendtem }} วัน
                </div>

                <v-btn
                  icon
                  @click="updateLicense(item.mt_id)"
                  color="grey"
                  dark
                >
                  <v-icon>mdi-magnify-close</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-chip color="error" outlined>
                  <v-icon>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                </v-chip>
              </div>
            </div>

            <div
              v-else-if="item.mt_license_status === 'waitpl'"
              class="error--text"
            >
              ขอ (P License) <br />
              <v-icon color="error" size="30">mdi-card-bulleted-off</v-icon>
            </div>

            <div
              v-else-if="item.mt_license_status === 'anything'"
              class="warning--text"
            >
              (P License) <br />
              <v-icon color="error" size="30">mdi-card-bulleted-off</v-icon>
            </div>

            <div v-if="item.pt_licence_file_ipa === 'pass'">
              <v-icon color="success">mdi-check-circle</v-icon>
            </div>

            <div
              v-else-if="item.pt_licence_file_ipa === 'dontpass'"
              class="error--text"
            >
              {{ item.pt_licence_file_ipacomment }}
            </div>

            <div v-if="item.pt_licence">
              <div v-if="String(item.pt_licence_file).length < 10">
                <v-chip color="error" outlined>
                  <v-icon>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                </v-chip>
              </div>
              <div v-else>
                <v-chip
                  @click="viewpdflicenseteach(item.pt_licence_file)"
                  outlined
                  color="info"
                >
                  <v-icon>mdi-magnify</v-icon>
                  {{ item.pt_licence }}</v-chip
                >
              </div>
              หมดอายุวันที่ <br />
              {{
                item.pt_enddate
                  | moment("add", "543 year")
                  | moment("D MMMM YYYY")
              }}
              <div
                v-if="item.datediffend <= 0"
                class="error--text font-weight-bold"
              >
                <v-icon color="error" size="30">mdi-alert</v-icon> <br />
                หมดก่อน {{ item.datediffend }} วัน
              </div>

              <br />
              <v-btn icon @click="updateLicense(item.mt_id)" color="grey" dark>
                <v-icon>mdi-magnify-close</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.approve_level1="{ item }">
            <div v-if="!item.atl1" class="grey--text caption">
              <span v-if="atl1Loading">กำลังตรวจสอบ...</span>
              <span v-else>ไม่อยู่ในบัญชีครูผู้ช่วย<br />(อนุมัติแล้ว/ย้ายออก)</span>
            </div>
            <v-tooltip v-else bottom max-width="420">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="text-no-wrap">
                  <v-chip
                    small
                    :color="item.atl1.eligible ? 'success' : 'error'"
                    dark
                    @click="showEligibility(item)"
                  >
                    <v-icon small left>
                      {{ item.atl1.eligible ? "mdi-check-decagram" : "mdi-close-octagon" }}
                    </v-icon>
                    {{ item.atl1.eligible ? "พร้อมอนุมัติ" : "ไม่ผ่าน " + item.atl1.failed.length + " ข้อ" }}
                  </v-chip>
                  <div class="mt-1">
                    <span
                      v-for="(r, i) in item.atl1.rounds.split('')"
                      :key="i"
                      class="atl1-round"
                      :class="'atl1-round-' + r"
                      >{{ i + 1 }}</span
                    >
                  </div>
                </div>
              </template>
              <div v-if="item.atl1.eligible">
                ผ่านทุกเงื่อนไข · ครบ 2 ปี {{ thaiDate(item.atl1.completion_date) }}
              </div>
              <div v-for="(r, i) in item.atl1.reasons" :key="i">• {{ r }}</div>
            </v-tooltip>
          </template>
          <template v-slot:item.pt_licence_ict="{ item }">
            <v-icon color="success" v-if="item.pt_licence_ict === 'ict'"
              >mdi-check-circle</v-icon
            >
            <v-icon color="error" v-else>mdi-close</v-icon>
          </template>

          <template v-slot:item.mt_time_1_score="{ item }">
            <div v-if="item.mt_time_1_ck === 'Pass'">
              <v-btn color="success" icon small>
                <v-icon>mdi-check-circle</v-icon>
              </v-btn>
            </div>

            <v-chip
              v-if="item.mt_time_1_score > 0"
              color="info"
              @click="viewFileScore((param = item.mt_time_1_file))"
            >
              <span class="font-weight-bold warning--text">{{
                item.mt_time_1_score
              }}</span>
            </v-chip>
          </template>

          <template v-slot:item.mt_time_2_score="{ item }">
            <div v-if="item.mt_time_2_ck === 'Pass'">
              <v-btn color="success" icon small>
                <v-icon>mdi-check-circle</v-icon>
              </v-btn>
            </div>

            <v-chip
              v-if="item.mt_time_2_score > 0"
              color="info"
              @click="viewFileScore((param = item.mt_time_2_file))"
            >
              <span class="font-weight-bold warning--text">{{
                item.mt_time_2_score
              }}</span>
            </v-chip>
          </template>

          <template v-slot:item.mt_time_3_score="{ item }">
            <div v-if="item.mt_time_3_ck === 'Pass'">
              <v-btn color="success" icon small>
                <v-icon>mdi-check-circle</v-icon>
              </v-btn>
            </div>
            <v-chip
              v-if="item.mt_time_3_score > 0"
              color="info"
              @click="viewFileScore((param = item.mt_time_3_file))"
            >
              <span class="font-weight-bold warning--text">{{
                item.mt_time_3_score
              }}</span>
            </v-chip>
          </template>

          <template v-slot:item.mt_time_4_score="{ item }">
            <div v-if="item.mt_time_4_ck === 'Pass'">
              <v-btn color="success" icon small>
                <v-icon>mdi-check-circle</v-icon>
              </v-btn>
            </div>
            <v-chip
              v-if="item.mt_time_4_score > 0"
              color="info"
              @click="viewFileScore((param = item.mt_time_4_file))"
            >
              <span class="font-weight-bold warning--text">{{
                item.mt_time_4_score
              }}</span>
            </v-chip>
          </template>

          <template v-slot:item.assistant_teacher_re_status="{ item }">
            <div v-if="item.assistant_teacher_re_status === 'CC'">
              <v-icon size="30" color="error"> mdi-alert</v-icon>
            </div>
            <div
              v-else-if="
                String(item.assistant_teacher_re_leaveguarantee).length > 4
              "
            >
              <v-icon size="30" color="success">mdi-check-circle</v-icon>
            </div>
          </template>

          <template v-slot:item.assistant_teacher_re_leaveguarantee="{ item }">
            <div
              v-if="String(item.assistant_teacher_re_leaveguarantee).length > 4"
            >
              <v-btn
                @click="
                  viewFileleavegurantee(
                    item.assistant_teacher_re_leaveguarantee
                  )
                "
                fab
                small
                color="info"
              >
                <v-icon size="30">mdi-printer</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.assistant_teacher_re_status_detail="{ item }">
            <div
              v-if="item.assistant_teacher_re_status === 'CC'"
              class="error--text"
            >
              {{ item.assistant_teacher_re_status_detail }}
            </div>
          </template>

          <template v-slot:item.evaluate_s="{ item }">
            <v-chip
              color="success"
              dark
              v-if="item.report_id_card === item.id_card"
            >
              <h2>
                <v-icon>mdi-checkbox-marked-circle</v-icon> ส่งผลการประเมิน
              </h2>
            </v-chip>
            <v-chip
              v-else-if="
                item.last_time_ass === '1' ||
                  item.last_time_ass === '2' ||
                  item.last_time_ass === '3' ||
                  item.last_time_ass === '4'
              "
              color="info"
              @click.stop="evaluate_assistant(item.mt_id_card)"
              dark
            >
              <h2>{{ item.last_time_ass }}</h2>
            </v-chip>
            <v-chip
              v-else
              dark
              color="error"
              @click.stop="evaluate_assistant(item.mt_id_card)"
            >
              <h2>
                <v-icon class="pa-1">mdi-cursor-pointer</v-icon>
                ไม่ได้เริ่มประเมิน
              </h2>
            </v-chip>
          </template>

          <template v-slot:item.prints="{ item }">
            <v-chip
              color="info"
              dark
              v-if="item.report_id_card === item.id_card"
            >
              <h2><v-icon>mdi-printer</v-icon> พิมพ์รายงาน</h2>
            </v-chip>
            <v-chip
              v-else-if="
                item.last_time_ass === '1' ||
                  item.last_time_ass === '2' ||
                  item.last_time_ass === '3' ||
                  item.last_time_ass === '4'
              "
              color="info"
              dark
            >
              <h2>อยู่ระหว่างการประเมิน</h2>
            </v-chip>
            <v-chip v-else color="error" dark>
              <h2>ไม่ได้เริ่มประเมิน</h2>
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
              color="warning"
              @click.stop="assistant_teacher_reportEdit(item)"
            >
              mdi-pencil
            </v-icon>
          </template>

          <template v-slot:item.cancels="{ item }">
            <v-icon
              color="error"
              @click.stop="evaluate_assistant(item.mt_id_card)"
            >
              mdi-cancel
            </v-icon>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </base-material-card>

      <!-- V-model evaluate_assistantdialog -->
      <v-layout row justify-center>
        <v-dialog v-model="evaluate_assistantdialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="success"
              icon="mdi-clipboard-text"
              title="บันทึกคะแนนการประเมิน รายบุคคล"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="evaluate_assistantform" lazy-validation>
                <v-container grid-list-md>
                  <v-card>
                    <template slot="progress">
                      <v-progress-linear
                        color="primary"
                        height="10"
                        indeterminate
                      ></v-progress-linear>
                    </template>

                    <v-card-title
                      ><v-icon large color="info">mdi-account-check</v-icon>
                      <h2>ข้อมูลครูผู้ช่วย ผู้รับการประเมิน</h2></v-card-title
                    >
                    <v-card-text>
                      <div class="my-4">
                        <h3>
                          สถานศึกษา :
                          {{ assistant_teacher_report_id_card.user_firstname }}
                        </h3>
                        รหัสบัตรประชาชน :
                        {{
                          assistant_teacher_report_id_card.assistant_teacher_re_id_card
                        }}
                        <br />
                        ชื่อ-นามสกุล :
                        {{ assistant_teacher_report_id_card.frist_names }}
                        <br />
                        วันที่บรรจุ :
                        {{
                          assistant_teacher_report_id_card.mt_date_app_now
                            | moment("add", "543 year")
                            | moment("D MMMM YYYY")
                        }}
                        <br />
                        คำสั่งที่บรรจุ :
                        {{ assistant_teacher_report_id_card.mt_order_app }}
                      </div>
                      <div class="my-4"></div>
                    </v-card-text>

                    <v-divider class="mx-4"></v-divider>

                    <v-card-title class="text-center">
                      <h3>ส่งผลการประเมิน</h3>
                    </v-card-title>
                    <v-row>
                      <v-col cols="12">
                        <v-data-table
                          :headers="headers_aassistant_teacher"
                          :items="assistant_teachers"
                          class="elevation-1"
                          :loading="loading"
                        >
                          |<!--  moment("add","543 years") | moment("D MMMM YYYY") -->

                          <template
                            v-slot:item.assistant_teacher_file="{ item }"
                          >
                            <v-btn
                              v-if="item.assistant_teacher_file"
                              large
                              icon
                              color="info"
                              @click="viewfilePDF(item.assistant_teacher_file)"
                            >
                              <v-icon>mdi-printer</v-icon>
                            </v-btn>
                          </template>

                          <template
                            v-slot:item.assistant_teacher_datetime="{
                              item
                            }"
                          >
                            {{
                              item.assistant_teacher_datetime
                                | moment("add", "543 years")
                                | moment("D MMMM YYYY")
                            }}
                          </template>

                          <template
                            v-slot:item.assistant_teacher_status="{ item }"
                          >
                            <v-chip
                              v-if="item.assistant_teacher_status === 'confirm'"
                              color="success"
                              dark
                            >
                              <h2>ส่งผลการประเมินเรียบร้อย</h2>
                            </v-chip>
                            <v-chip v-else color="warning" dark>
                              <h2>อยู่ระหว่างการประเมินผล</h2>
                            </v-chip>
                          </template>

                          <template
                            v-slot:item.assistant_teacher_comment="{ item }"
                          >
                            <v-icon
                              v-if="item.assistant_teacher_status === 'confirm'"
                              color="success"
                              large
                            >
                              mdi-cube-send
                            </v-icon>
                            <v-icon
                              v-else
                              large
                              color="warning"
                              @click.stop="
                                assistant_teacherEdit(item.assistant_teacher_id)
                              "
                            >
                              mdi-pencil
                            </v-icon>
                          </template>
                        </v-data-table>

                        <v-simple-table>
                          <tbody>
                            <tr>
                              <td class="text-center">
                                วันที่ส่งรายงาน :
                                {{
                                  assistant_teacher_report_id_card.assistant_teacher_re_datetime
                                }}
                              </td>
                              <td class="text-center">
                                คะแนนเฉลี่ยรวม :
                                {{
                                  assistant_teacher_report_id_card.assistant_teacher_re_avg_score
                                }}
                              </td>

                              <td class="text-center">
                                จำนวนวันลา :
                                {{
                                  assistant_teacher_report_id_card.assistant_teacher_re_leaveday
                                }}
                                วัน
                              </td>

                              <td class="text-center">
                                หนังสือรับรอง :
                                <v-btn
                                  @click="
                                    viewFileleavegurantee(
                                      assistant_teacher_report_id_card.assistant_teacher_re_leaveguarantee
                                    )
                                  "
                                  color="info"
                                  fab
                                  small
                                  ><v-icon>mdi-printer</v-icon></v-btn
                                >
                              </td>

                              <td
                                class="text-center error--text font-weight-bold"
                              >
                                หมายเหตุ
                                {{
                                  assistant_teacher_report_id_card.assistant_teacher_re_status_detail
                                }}
                              </td>

                              <td class="text-center">
                                <v-btn
                                  @click="assistant_teacher_reportSubmit()"
                                  outlined
                                  color="warning"
                                >
                                  <v-icon size="30" color="warning"
                                    >mdi-alert</v-icon
                                  >
                                  ยกเลิกรายการ สรุปวันลา</v-btn
                                >
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn
                        @click="cancel_assistant_teacher_report()"
                        color="error"
                        outlined
                        rounded
                      >
                        <v-icon>mdi-alert</v-icon>
                        &nbsp; ยกเลิกรายการประเมิน
                      </v-btn>
                      <v-spacer></v-spacer>

                      <v-btn
                        outlined
                        @click.stop="evaluate_assistantdialog = false"
                        rounded
                      >
                        <v-icon dark>mdi-close</v-icon>ปิด
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model assistant_teacherdialog -->
      <v-layout row justify-center>
        <v-dialog v-model="assistant_teacherdialog" persistent max-width="60%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="success"
              icon="mdi-clipboard-text"
              title="บันทึกคะแนนประเมิน"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="assistant_teacherdialogform" lazy-validation>
                <v-container grid-list-md>
                  <v-card-text>
                    <div class="my-4">
                      <h3>
                        สถานศึกษา :
                        {{ assistant_teacher_report_id_card.college_name }}
                      </h3>
                      รหัสบัตรประชาชน :
                      {{
                        assistant_teacher_report_id_card.assistant_teacher_re_id_card
                      }}
                      <br />
                      ชื่อ-นามสกุล :
                      {{ assistant_teacher_report_id_card.frist_names }} <br />
                      วันที่บรรจุ :
                      {{ assistant_teacher_report_id_card.date_app }} <br />
                      คำสั่งที่บรรจุ :
                      {{ assistant_teacher_report_id_card.order_app_now }}
                      <br />
                      <br />

                      <h3>ครั้งที่ประเมิน : {{ times_s }}</h3>
                    </div>
                    <div class="my-4"></div>
                  </v-card-text>
                  <v-layout wrap>
                    <v-flex md12 class="text-center">
                      <h3>คะแนนประเมิน</h3>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        v-model="addassistant_teacher.assistant_teacher_score"
                        type="number"
                        label="คะแนน"
                        required
                        :rules="[
                          v => !!v || '',
                          v => (!!v && v <= 100) || 'กรอกคะแนนไม่ถูกต้อง'
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="
                              addassistant_teacher.assistant_teacher_datetime
                            "
                            label="วันที่ประเมิน"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            locale="th"
                            required
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="
                            addassistant_teacher.assistant_teacher_datetime
                          "
                          no-title
                          scrollable
                          locale="th"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu2 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
                <strong class="error--text"
                  >* ปีที่ 1 (ไม่ต่ำกว่าร้อยละ 60 จึงจะถือว่า
                  ผ่านการประเมิน)</strong
                >
                <br />
                <strong class="error--text"
                  >* ปีที่ 2 (ไม่ต่ำกว่าร้อยละ 70 จึงจะถือว่า
                  ผ่านการประเมิน)</strong
                >
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="assistant_teacherdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="assistant_teacherdialogSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model assistant_teacherEditdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="assistant_teacherEditdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="แก้ไขคะแนนประเมิน"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="assistant_teacherEditform" lazy-validation>
                <v-container grid-list-md>
                  <v-card-text>
                    <div class="my-4">
                      <h3>
                        สถานศึกษา :
                        {{ assistant_teacher_report_id_card.college_name }}
                      </h3>
                      รหัสบัตรประชาชน :
                      {{
                        assistant_teacher_report_id_card.assistant_teacher_re_id_card
                      }}
                      <br />
                      ชื่อ-นามสกุล :
                      {{ assistant_teacher_report_id_card.frist_names }} <br />
                      วันที่บรรจุ :
                      {{ assistant_teacher_report_id_card.date_app }} <br />
                      คำสั่งที่บรรจุ :
                      {{ assistant_teacher_report_id_card.order_app_now }}
                      <br />
                      <br />

                      <h3>
                        ครั้งที่ประเมิน :
                        {{ assistant_teachers_edit.assistant_teacher_times }}
                      </h3>
                    </div>
                    <div class="my-4"></div>
                  </v-card-text>
                  <v-layout wrap>
                    <v-flex md12 class="text-center">
                      <h3>คะแนนประเมิน</h3>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        v-model="
                          assistant_teachers_edit.assistant_teacher_score
                        "
                        type="number"
                        label="คะแนน"
                        required
                        :rules="[
                          v => !!v || '',
                          v => (!!v && v <= 100) || 'กรอกคะแนนไม่ถูกต้อง'
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="
                              assistant_teachers_edit.assistant_teacher_datetime
                            "
                            label="วันที่ประเมิน"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            locale="th"
                            required
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="
                            assistant_teachers_edit.assistant_teacher_datetime
                          "
                          no-title
                          scrollable
                          locale="th"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu1 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu1.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
                <strong class="error--text"
                  >* ปีที่ 1 (ไม่ต่ำกว่าร้อยละ 60 จึงจะถือว่า
                  ผ่านการประเมิน)</strong
                >
                <br />
                <strong class="error--text"
                  >* ปีที่ 2 (ไม่ต่ำกว่าร้อยละ 70 จึงจะถือว่า
                  ผ่านการประเมิน)</strong
                >
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="assistant_teacherEditdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="assistant_teacherEditdialogSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model assistant_teacherConfirmdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="assistant_teacherConfirmdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="ยืนยันผลการประเมิน"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="assistant_teacherConfirmdialogform" lazy-validation>
                <v-container grid-list-md>
                  <v-card-text>
                    <div class="my-4">
                      <h3>
                        สถานศึกษา :
                        {{ assistant_teacher_report_id_card.college_name }}
                      </h3>
                      รหัสบัตรประชาชน :
                      {{
                        assistant_teacher_report_id_card.assistant_teacher_re_id_card
                      }}
                      <br />
                      ชื่อ-นามสกุล :
                      {{ assistant_teacher_report_id_card.frist_names }} <br />
                      วันที่บรรจุ :
                      {{ assistant_teacher_report_id_card.date_app }} <br />
                      คำสั่งที่บรรจุ :
                      {{ assistant_teacher_report_id_card.order_app_now }}
                      <br />
                      <h3>
                        คะแนนเฉลี่ย :
                        {{ assistant_teacher_report_id_card.avg_score }}
                      </h3>
                      <br />

                      <h3>
                        หากกดปุ่มยืนยันแล้วจะไม่สามารถดำเนินการแก้ไขได้
                        กรุณาตรวจสอบให้ถูกต้องก่อนกดปุ่มยืนยัน
                      </h3>
                    </div>
                    <div class="my-4"></div>
                  </v-card-text>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                @click.stop="assistant_teacherConfirmdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="assistant_teacherConfirmdialogSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon>&nbsp;ยืนยันผลการประเมิน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model cancel_assistant_teacher_reportdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="cancel_assistant_teacher_reportdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="ยกเลิกการประเมินผล"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form
                ref="cancel_assistant_teacher_reportdialogform"
                lazy-validation
              >
                <v-container grid-list-md>
                  <v-card-text>
                    <div class="my-4">
                      <h3>
                        สถานศึกษา :
                        {{ assistant_teacher_report_id_card.user_firstname }}
                      </h3>
                      รหัสบัตรประชาชน :
                      {{
                        assistant_teacher_report_id_card.assistant_teacher_re_id_card
                      }}
                      <br />
                      ชื่อ-นามสกุล :
                      {{ assistant_teacher_report_id_card.frist_names }}
                      <br />
                      วันที่บรรจุ :
                      {{
                        assistant_teacher_report_id_card.mt_date_app_now
                          | moment("add", "543 year")
                          | moment("D MMMM YYYY")
                      }}
                      <br />
                      คำสั่งที่บรรจุ :
                      {{ assistant_teacher_report_id_card.mt_order_app }}
                    </div>
                    <div class="my-4">
                      <v-text-field
                        v-model="
                          cancel_assistant_teachers.assistant_teacher_ipacomment
                        "
                        label="เหตุผลในการยกเลิก"
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </div>
                  </v-card-text>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                @click.stop="cancel_assistant_teacher_reportdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="cancel_assistant_teacher_reportdialogSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon
                >&nbsp;ยืนยันการยกเลิกผลการประเมิน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model pertem_assistantFileCCdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="pertem_assistantFileCCdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="error"
              icon="mdi-clipboard-text"
              title="ยกเลิกแนบคำสั่งแต่งตั้งกรรมการประเมิน"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="pertem_assistantFileCCform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <div class="my-4">
                        <h3>
                          สถานศึกษา :
                          {{ editassistant_teacher_report.college_name }}
                        </h3>
                        รหัสบัตรประชาชน :
                        {{ editassistant_teacher_report.id_card }} <br />
                        ชื่อ-นามสกุล :
                        {{ editassistant_teacher_report.frist_names }} <br />
                        วันที่บรรจุ :
                        {{ editassistant_teacher_report.date_app }} <br />
                        คำสั่งที่บรรจุ :
                        {{ editassistant_teacher_report.order_app_now }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="success"
                @click.stop="pertem_assistantFileCCSubmit()"
                rounded
              >
                <v-icon dark>mdi-checkbox-marked-circle</v-icon
                >&nbsp;ยืนยันยกเลิก
              </v-btn>
              <v-btn
                outlined
                color="warning"
                @click.stop="pertem_assistantFileCCdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model editassistant_teacher_reportdialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="editassistant_teacher_reportdialog"
          persistent
          max-width="60%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="ปรับปรุงข้อมูลบุคลากร"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="editassistant_teacher_reportform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <h3>ข้อมูลการเริ่มปฏิบัติหน้าที่ในสถานศึกษาปัจจุบัน</h3>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        label="คำสั่งที่ ระบุเพียง : 783/2563"
                        v-model="editassistant_teacher_report.order_app_now"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editassistant_teacher_report.date_app_now"
                            label="วันเดือนเริ่มปฏิบัติงาน"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            locale="th"
                            required
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editassistant_teacher_report.date_app_now"
                          no-title
                          scrollable
                          locale="th"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu3 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu3.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
                <strong class="error--text">* จำเป็น</strong>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="editassistant_teacher_reportdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="editassistant_teacher_reportSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="pdflicenseteachdialog" max-width="80%">
          <v-card class="" elevation="2">
            <embed
              :src="
                'https://hrvec.ovec.go.th/HRvecLicenseTeach/' + pt_licence_files
              "
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="scoredialog" max-width="80%">
          <v-card class="" elevation="2">
            <embed
              :src="'https://hrvec.ovec.go.th/HRvecfiles/' + assFileScore"
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog
          v-model="assistant_teacher_re_leaveguaranteedialog"
          max-width="80%"
        >
          <v-card class="" elevation="2">
            <embed
              :src="
                'https://hrvec.ovec.go.th/HRvecAssistant_report/' +
                  assistant_teacher_re_leaveguarantee
              "
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- ยกเลิกไฟล์แนบใบอนุญาตประกอบวิชาชีพครู -->

      <v-dialog v-model="cancel_Licensefiledialog" persistent max-width="60%">
        <v-card class="mx-auto pa-6">
          <base-material-card
            color="warning"
            icon="mdi-clipboard-text"
            title="การตรวจสอบข้อมูล ใบอนุญาตประกอบวิชาชีพครู/ใบอนุญาตปฏิบัติการสอน"
            class="px-5 py-3 text_google"
          ></base-material-card>
          <v-card-text>
            <v-form ref="cancel_Licensefiledialogform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    <div class="text-center">
                      <v-btn
                        v-if="
                          String(editmanage_assistant_teacher.pt_licence_file)
                            .length > 6
                        "
                        color="info"
                        icon
                        @click="
                          viewpdflicenseteach(
                            editmanage_assistant_teacher.pt_licence_file
                          )
                        "
                        ><v-icon size="60">mdi-printer</v-icon></v-btn
                      >
                    </div>

                    <div class="text-center">
                      <v-btn
                        v-if="
                          String(
                            editmanage_assistant_teacher.pt_licence_file_tem
                          ).length > 6
                        "
                        color="info"
                        icon
                        @click="
                          viewpdflicenseteach(
                            editmanage_assistant_teacher.pt_licence_file_tem
                          )
                        "
                        ><v-icon size="60">mdi-printer</v-icon></v-btn
                      >
                    </div>

                    <br />
                    ชื่อ-นามสกุล :
                    <span class="font-weight-bold"
                      >{{ editmanage_assistant_teacher.frist_names }}
                    </span>
                    <br />
                    ID-card :
                    {{ editmanage_assistant_teacher.mt_id_card }}
                  </v-flex>

                  <v-flex
                    md6
                    v-if="
                      editmanage_assistant_teacher.mt_license_status === 'have'
                    "
                  >
                    <v-radio-group
                      v-model="editmanage_assistant_teacher.pt_licence_file_ipa"
                      row
                      :rules="[v => !!v || '']"
                    >
                      <template v-slot:label>
                        <div><strong>การตรวจสอบข้อมูล</strong></div>
                      </template>
                      <v-radio value="pass">
                        <template v-slot:label>
                          <div>
                            <strong class="success--text">ผ่าน</strong>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="dontpass">
                        <template v-slot:label>
                          <div>
                            <strong class="primary--text">ไม่ผ่าน</strong>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex
                    md6
                    v-if="
                      editmanage_assistant_teacher.pt_licence_file_ipa ===
                        'dontpass' &&
                        editmanage_assistant_teacher.mt_license_status ===
                          'have'
                    "
                  >
                    <v-text-field
                      label="เหตุผล"
                      v-model="
                        editmanage_assistant_teacher.pt_licence_file_ipacomment
                      "
                      required
                      :rules="[v => !!v || '']"
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex
                    md6
                    v-if="
                      editmanage_assistant_teacher.mt_license_status === 'donot'
                    "
                  >
                    <v-radio-group
                      v-model="
                        editmanage_assistant_teacher.pt_licence_file_ipa_tem
                      "
                      row
                      :rules="[v => !!v || '']"
                    >
                      <template v-slot:label>
                        <div>
                          การตรวจสอบข้อมูล<strong>
                            ใบอนุญาตปฏิบัติการสอน</strong
                          >
                        </div>
                      </template>
                      <v-radio value="pass">
                        <template v-slot:label>
                          <div>
                            <strong class="success--text">ผ่าน</strong>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="dontpass">
                        <template v-slot:label>
                          <div>
                            <strong class="primary--text">ไม่ผ่าน</strong>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex
                    md6
                    v-if="
                      editmanage_assistant_teacher.pt_licence_file_ipa_tem ===
                        'dontpass' &&
                        editmanage_assistant_teacher.mt_license_status ===
                          'donot'
                    "
                  >
                    <v-text-field
                      label="เหตุผล"
                      v-model="
                        editmanage_assistant_teacher.pt_licence_file_ipacomment_tem
                      "
                      required
                      :rules="[v => !!v || '']"
                      outlined
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <strong class="error--text">* จำเป็น</strong>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              outlined
              @click.stop="cancel_Licensefiledialog = false"
              rounded
            >
              <v-icon dark>mdi-close</v-icon>
            </v-btn>

            <v-btn
              outlined
              color="success"
              @click.stop="cancel_LicensefiledialogSubmit()"
              rounded
            >
              <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout row justify-center>
        <v-dialog v-model="importCsvDialog" max-width="500px" persistent>
          <v-card class="mx-auto pa-4">
            <base-material-card
              color="primary"
              icon="mdi-file-delimited"
              title="นำเข้าข้อมูลจาก CSV (อนุมัติ คศ.1)"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text class="pt-4">
              <v-alert type="info" outlined dense class="mb-4">
                ไฟล์ CSV 2 คอลัมน์ (มีหรือไม่มีแถวหัวตารางก็ได้):<br />
                <b>คอลัมน์ 1:</b> รหัสบัตรประชาชน 13 หลัก<br />
                <b>คอลัมน์ 2:</b> วันที่ให้ดำรงตำแหน่งครู รูปแบบ YYYY-MM-DD
                (ค.ศ. หรือ พ.ศ. เช่น 2026-03-30 หรือ 2569-03-30)
                เว้นว่างได้ = ใช้วันครบ 2 ปีของแต่ละราย
              </v-alert>
              <v-alert type="warning" outlined dense class="mb-4">
                ทุกรายการในไฟล์จะถูกตรวจเงื่อนไขเดียวกับการอนุมัติในตาราง
                รายที่ไม่ผ่านจะไม่ถูกอนุมัติ และแสดงเหตุผลหลังนำเข้า
              </v-alert>

              <v-file-input
                v-model="csvFile"
                accept=".csv"
                label="เลือกไฟล์ CSV"
                placeholder="อัปโหลดไฟล์ที่นี่"
                prepend-icon="mdi-file-delimited"
                outlined
                dense
                show-size
              ></v-file-input>
              <v-text-field
                v-model="csvOrderNo"
                label="เลขที่คำสั่ง (ถ้ามี)"
                outlined
                dense
              ></v-text-field>
              <v-btn
                small
                text
                color="primary"
                :disabled="selected.length === 0"
                @click="downloadCsvTemplate()"
              >
                <v-icon left small>mdi-download</v-icon>
                ดาวน์โหลดแม่แบบจากรายชื่อที่เลือก ({{ selected.length }})
              </v-btn>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large rounded @click="importCsvDialog = false">
                <v-icon dark left>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="primary"
                rounded
                @click="processCSV()"
                :loading="csvLoading"
              >
                <v-icon dark left>mdi-upload</v-icon>ตรวจสอบและนำเข้า
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- ยืนยันอนุมัติ คศ.1 -->
      <v-dialog v-model="approveDialog" max-width="900px" persistent scrollable>
        <v-card>
          <v-card-title class="success white--text">
            <v-icon dark left>mdi-account-check</v-icon>
            ยืนยันอนุมัติให้ดำรงตำแหน่งครู คศ.1 ({{ selectedRows.length }} ราย)
          </v-card-title>
          <v-card-text class="pt-4">
            <v-simple-table dense fixed-header height="260px" class="mb-4">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ชื่อ-นามสกุล</th>
                  <th>สถานศึกษา</th>
                  <th class="text-center">คะแนนเฉลี่ย</th>
                  <th class="text-center">ครบ 2 ปี</th>
                  <th>ใบอนุญาต (หมดอายุ)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in selectedRows" :key="r.id_card">
                  <td>{{ i + 1 }}</td>
                  <td>{{ r.full_name }}</td>
                  <td>{{ r.college_name }}</td>
                  <td class="text-center">{{ r.avg_score }}</td>
                  <td class="text-center">{{ thaiDate(r.completion_date) }}</td>
                  <td>{{ r.licence_no }} ({{ thaiDate(r.licence_enddate) }})</td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-form ref="approveForm" lazy-validation>
              <v-radio-group v-model="approveForm.mode" class="mt-0" hide-details>
                <template v-slot:label>
                  <strong>วันที่ให้ดำรงตำแหน่งครู คศ.1 (วันที่มีผล)</strong>
                </template>
                <v-radio
                  value="auto"
                  label="ใช้วันครบ 2 ปีนับจากวันบรรจุ ของแต่ละราย (แนะนำ)"
                ></v-radio>
                <v-radio value="fixed" label="กำหนดวันเดียวกันทุกราย"></v-radio>
              </v-radio-group>
              <v-row class="mt-2">
                <v-col cols="12" md="4" v-if="approveForm.mode === 'fixed'">
                  <v-text-field
                    v-model="approveForm.effective_date"
                    type="date"
                    label="วันที่มีผล (ค.ศ.)"
                    outlined
                    dense
                    :rules="[v => !!v || 'ระบุวันที่มีผล']"
                    :hint="approveForm.effective_date ? thaiDate(approveForm.effective_date) : ''"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="approveForm.order_no"
                    label="เลขที่คำสั่ง (ถ้ามี)"
                    placeholder="เช่น 1234/2569"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="approveForm.order_date"
                    type="date"
                    label="ลงวันที่คำสั่ง (ถ้ามี)"
                    outlined
                    dense
                    :hint="approveForm.order_date ? thaiDate(approveForm.order_date) : ''"
                    persistent-hint
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-alert type="warning" dense outlined class="mt-2 mb-0">
                ระบบจะตรวจเงื่อนไขซ้ำอีกครั้งก่อนบันทึก รายที่ผ่านจะถูกปรับตำแหน่งเป็น
                <b>ครู คศ.1</b> และย้ายออกจากบัญชีครูผู้ช่วย (เก็บสำเนาไว้ที่
                manage_assistant_teacher_backup และประวัติการอนุมัติ)
              </v-alert>
              <v-checkbox
                v-model="approveForm.confirm"
                hide-details
                label="ข้าพเจ้าตรวจสอบรายชื่อและข้อมูลข้างต้นแล้ว"
              ></v-checkbox>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="approveDialog = false" :disabled="approving">ยกเลิก</v-btn>
            <v-btn
              color="success"
              :disabled="!approveForm.confirm"
              :loading="approving"
              @click="submitApprove()"
            >
              <v-icon left>mdi-check-all</v-icon>
              ยืนยันอนุมัติ {{ selectedRows.length }} ราย
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ผลการอนุมัติ -->
      <v-dialog v-model="resultDialog" max-width="820px" scrollable>
        <v-card v-if="approveResult">
          <v-card-title>
            <v-icon left :color="approveResult.approved.length ? 'success' : 'error'">
              {{ approveResult.approved.length ? "mdi-check-circle" : "mdi-alert-circle" }}
            </v-icon>
            ผลการอนุมัติ
          </v-card-title>
          <v-card-text>
            <div class="mb-3">
              <v-chip color="success" dark class="mr-2">
                อนุมัติสำเร็จ {{ approveResult.approved.length }} ราย
              </v-chip>
              <v-chip color="error" dark>
                ไม่อนุมัติ {{ approveResult.rejected.length }} ราย
              </v-chip>
              <div v-if="approveResult.batch_id" class="caption mt-2">
                รหัสชุดการอนุมัติ: {{ approveResult.batch_id }}
              </div>
              <div v-if="!approveResult.approved.length && approveResult.message" class="error--text mt-2">
                {{ approveResult.message }}
              </div>
            </div>
            <div v-if="approveResult.rejected.length">
              <div class="subtitle-2 error--text mb-1">รายที่ไม่ได้อนุมัติ และเหตุผล</div>
              <v-simple-table dense>
                <tbody>
                  <tr v-for="r in approveResult.rejected" :key="'rj' + r.id_card">
                    <td class="text-no-wrap">{{ r.id_card }}</td>
                    <td>{{ r.full_name }}</td>
                    <td>
                      <div v-for="(x, i) in r.reasons" :key="i">• {{ x }}</div>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
            <div v-if="approveResult.approved.length" class="mt-4">
              <div class="subtitle-2 success--text mb-1">รายที่อนุมัติแล้ว</div>
              <v-simple-table dense>
                <tbody>
                  <tr v-for="r in approveResult.approved" :key="'ap' + r.id_card">
                    <td class="text-no-wrap">{{ r.id_card }}</td>
                    <td>{{ r.full_name }}</td>
                    <td>{{ r.college_name }}</td>
                    <td class="text-no-wrap">มีผล {{ thaiDate(r.effective_date) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="resultDialog = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- รายละเอียดเงื่อนไขรายบุคคล -->
      <v-dialog v-model="eligibilityDialog" max-width="560px">
        <v-card v-if="eligibilityItem">
          <v-card-title class="subtitle-1 font-weight-bold">
            {{ eligibilityItem.full_name }}
          </v-card-title>
          <v-card-subtitle>
            {{ eligibilityItem.college_name }} · บรรจุ
            {{ thaiDate(eligibilityItem.appoint_date) }} · ครบ 2 ปี
            {{ thaiDate(eligibilityItem.completion_date) }}
          </v-card-subtitle>
          <v-card-text>
            <v-list dense>
              <v-list-item v-for="c in atl1CheckDefs" :key="c.key">
                <v-list-item-icon class="mr-3">
                  <v-icon :color="eligibilityItem.failed.includes(c.key) ? 'error' : 'success'">
                    {{ eligibilityItem.failed.includes(c.key) ? "mdi-close-circle" : "mdi-check-circle" }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ c.label }}</v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">{{ c.hint }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-alert v-if="eligibilityItem.reasons.length" type="error" dense outlined>
              <div v-for="(r, i) in eligibilityItem.reasons" :key="i">• {{ r }}</div>
            </v-alert>
            <v-alert v-else type="success" dense outlined>
              ผ่านทุกเงื่อนไข เลือกในตารางเพื่ออนุมัติได้
            </v-alert>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- ประวัติการอนุมัติ -->
      <v-dialog v-model="historyDialog" max-width="1200px" scrollable>
        <v-card>
          <v-card-title>
            <v-icon left>mdi-history</v-icon> ประวัติการอนุมัติ ครู คศ.1
            <v-spacer></v-spacer>
            <v-text-field
              v-model="historySearch"
              append-icon="mdi-magnify"
              label="ค้นหา ชื่อ / รหัสบัตร / เลขที่คำสั่ง / รหัสชุด"
              dense
              hide-details
              outlined
              style="max-width: 380px"
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-alert v-if="historyMessage" type="warning" dense outlined>{{ historyMessage }}</v-alert>
            <v-data-table
              :headers="historyHeaders"
              :items="historyRows"
              :search="historySearch"
              :loading="historyLoading"
              dense
              :items-per-page="25"
              no-data-text="ยังไม่มีประวัติการอนุมัติ"
            >
              <template v-slot:item.effective_date="{ item }">{{ thaiDate(item.effective_date) }}</template>
              <template v-slot:item.appoint_date="{ item }">{{ thaiDate(item.appoint_date) }}</template>
              <template v-slot:item.order_no="{ item }">
                {{ item.order_no || "-" }}
                <span v-if="item.order_date" class="caption"><br />{{ thaiDate(item.order_date) }}</span>
              </template>
              <template v-slot:item.source="{ item }">
                <v-chip x-small :color="item.source === 'csv' ? 'primary' : 'success'" dark>
                  {{ item.source === "csv" ? "CSV" : "ตาราง" }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="historyDialog = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- คู่มือการใช้งาน -->
      <v-dialog v-model="helpDialog" max-width="900px" scrollable>
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon dark left>mdi-book-open-variant</v-icon>
            คู่มือการใช้งาน: รายงานผลการประเมินและอนุมัติครู คศ.1
          </v-card-title>
          <v-card-text class="pt-4 atl1-help">
            <h3>1. เงื่อนไขการอนุมัติ (ต้องผ่านครบทุกข้อ)</h3>
            <p>
              ระบบตรวจเงื่อนไขทุกครั้งที่โหลดตาราง และตรวจซ้ำที่เซิร์ฟเวอร์ตอนกดอนุมัติ
              ผู้ที่ไม่ผ่านจะเลือกไม่ได้ (ช่องเลือกเป็นสีจาง) และอนุมัติผ่าน CSV ไม่ได้เช่นกัน
            </p>
            <v-simple-table dense class="mb-4">
              <tbody>
                <tr v-for="c in atl1CheckDefs" :key="'h' + c.key">
                  <td class="text-no-wrap"><v-icon small left>{{ c.icon }}</v-icon><b>{{ c.label }}</b></td>
                  <td>{{ c.hint }}</td>
                </tr>
              </tbody>
            </v-simple-table>

            <h3>2. อ่านคอลัมน์ "ความพร้อม คศ.1"</h3>
            <ul>
              <li><v-chip x-small color="success" dark>พร้อมอนุมัติ</v-chip> ผ่านทุกเงื่อนไข</li>
              <li><v-chip x-small color="error" dark>ไม่ผ่าน N ข้อ</v-chip> ชี้เมาส์ดูเหตุผล หรือคลิกเพื่อดูรายละเอียดทีละเงื่อนไข</li>
              <li>
                ตัวเลข 1-4 ใต้ป้าย คือผลประเมินแต่ละครั้ง:
                <span class="atl1-round atl1-round-P">1</span> ผ่าน
                <span class="atl1-round atl1-round-W">2</span> รอ สอศ. ตรวจสอบ
                <span class="atl1-round atl1-round-F">3</span> ไม่ผ่าน
                <span class="atl1-round atl1-round--">4</span> ยังไม่ส่งผล
              </li>
              <li>"ไม่อยู่ในบัญชีครูผู้ช่วย" = อนุมัติไปแล้วหรือย้ายออก จึงไม่มีให้เลือก</li>
            </ul>

            <h3>3. ขั้นตอนอนุมัติหลายรายพร้อมกัน</h3>
            <ol>
              <li>เลือกขอบเขตข้อมูลด้วย <b>เครื่องมือค้นหาและกรอง</b> ด้านบน (วิทยาลัย หรือ วันเดือนปีที่บรรจุ) หรือช่องค้นหาในตาราง</li>
              <li>กด <b>พร้อมอนุมัติ</b> เพื่อดูเฉพาะผู้ผ่านเงื่อนไข</li>
              <li>ติ๊กเลือกทีละราย หรือกด <b>เลือกทุกคนที่พร้อมอนุมัติ</b> (เลือกตามตัวกรอง/คำค้นปัจจุบัน)</li>
              <li>กด <b>อนุมัติที่เลือก</b> ตรวจรายชื่อ เลือกวันที่มีผล ใส่เลขที่คำสั่ง (ถ้ามี) ติ๊กยืนยัน แล้วกดยืนยันอนุมัติ</li>
              <li>ระบบแสดงผลรายที่สำเร็จ และรายที่ไม่สำเร็จพร้อมเหตุผล (เช่น ข้อมูลเปลี่ยนระหว่างเปิดหน้า)</li>
            </ol>

            <h3>4. วันที่มีผล</h3>
            <ul>
              <li><b>ใช้วันครบ 2 ปี (แนะนำ)</b>: แต่ละรายได้วันที่ครบ 2 ปีนับจากวันบรรจุของตนเอง</li>
              <li><b>กำหนดวันเดียวกันทุกราย</b>: ใช้ตามคำสั่ง ต้องไม่ก่อนวันครบ 2 ปีของแต่ละราย (รายที่ขัดจะถูกปฏิเสธ)</li>
              <li>ใบอนุญาตต้องยังไม่หมดอายุ ณ วันที่มีผลและวันที่อนุมัติ</li>
            </ul>

            <h3>5. เครื่องมืออื่น</h3>
            <ul>
              <li><b>กรองตามเงื่อนไขที่ไม่ผ่าน</b>: คลิกชิปเพื่อดูเฉพาะผู้ที่ติดเงื่อนไขนั้น ใช้ติดตามกับสถานศึกษา คลิกซ้ำเพื่อยกเลิก</li>
              <li><b>ส่งออกรายชื่อ</b>: ไฟล์ CSV ของรายการที่แสดงอยู่ พร้อมสถานะและเหตุผล ใช้จัดทำบัญชีแนบท้ายคำสั่งหรือแจ้งสถานศึกษา</li>
              <li><b>นำเข้า CSV</b>: อนุมัติตามรายชื่อในไฟล์ (รหัสบัตร, วันที่มีผล) ผ่านการตรวจเงื่อนไขเดียวกัน ดาวน์โหลดแม่แบบจากรายชื่อที่เลือกได้</li>
              <li><b>ประวัติการอนุมัติ</b>: ดูว่าใครอนุมัติใคร เมื่อไร วันที่มีผล เลขที่คำสั่ง และรหัสชุด</li>
              <li><b>ใบอนุญาต</b> (ไอคอนแว่นขยายในคอลัมน์ใบประกอบวิชาชีพ): ตรวจไฟล์ผ่าน/ไม่ผ่าน กรณีไม่ผ่านระบบจะลบไฟล์และสถานศึกษาต้องแนบใหม่</li>
              <li><b>ยกเลิกการประเมิน</b> (ไอคอน ⊘ ท้ายแถว): เปิดผลประเมินรายบุคคล ยกเลิกสรุปวันลาหรือยกเลิกผลการประเมินเพื่อให้สถานศึกษาส่งใหม่</li>
              <li><b>ปุ่มพิมพ์</b> ในเครื่องมือค้นหา: พิมพ์รายงานสรุปผลคะแนน ทั้งหมด หรือตามวันบรรจุ</li>
            </ul>

            <h3>6. หากต้องการแก้ไขหลังอนุมัติ</h3>
            <p>
              ข้อมูลเดิมของผู้ได้รับอนุมัติเก็บไว้ในตาราง manage_assistant_teacher_backup
              (หน้า สำรองข้อมูลครูผู้ช่วย) และสำเนาเต็มอยู่ในประวัติการอนุมัติ ใช้ย้อนกลับได้
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="helpDialog = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>
          {{ snackbar.text }}
        </v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import Assistant_teacher_bar from "../../components/admin/assistant_teacher_bar.vue";
export default {
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      valid: true,
      scoredialog: false,
      assFileScore: "",
      addassistant_teacher_reportdialog: false,
      editassistant_teacher_reportdialog: false,
      deleteassistant_teacher_reportdialog: false,
      evaluate_assistantdialog: false,
      assistant_teacherdialog: false,
      assistant_teacherEditdialog: false,
      assistant_teacherConfirmdialog: false,
      cancel_assistant_teacher_reportdialog: false,
      pertem_assistantFileCCdialog: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      assistant_teacher_reports: [],
      addassistant_teacher_report: {},
      editassistant_teacher_report: {},
      search: "",
      pagination: {},
      headers: [
        { text: "ลำดับ", align: "center", value: "order_number" },
        { text: "ประเภท", align: "left", value: "mt_type_personnel" },
        { text: "รหัสสถานศึกษา", align: "left", value: "mt_college_code" },
        { text: "เข้าสู่ระบบสถานศึกษา", align: "left", value: "LoginAdmin" },
        { text: "สถานศึกษา", align: "left", value: "user_firstname" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "รหัสบัตรประชาชน", align: "left", value: "mt_id_card" },
        { text: "ชื่อ-นามสกุล", align: "left", value: "frist_names" },
        { text: "เลขที่ตำแหน่ง", align: "center", value: "mt_id_position" },
        { text: "ใบประกอบวิชาชีพ", align: "center", value: "pt_licence" },
        { text: "คุรุสภา", align: "center", value: "pt_licence_ict" },
        { text: "ความพร้อม คศ.1", align: "center", value: "approve_level1", sortable: false },

        { text: "ครั้งที่ 1", align: "center", value: "mt_time_1_score" },
        { text: "ครั้งที่ 2", align: "center", value: "mt_time_2_score" },
        { text: "ครั้งที่ 3", align: "center", value: "mt_time_3_score" },
        { text: "ครั้งที่ 4", align: "center", value: "mt_time_4_score" },
        {
          text: "คะแนน",
          align: "center",
          value: "assistant_teacher_re_avg_score"
        },

        {
          text: "วันลา",
          align: "center",
          value: "assistant_teacher_re_leaveday"
        },

        {
          text: "ไฟล์รับรองวันลา",
          align: "center",
          value: "assistant_teacher_re_leaveguarantee"
        },

        {
          text: "สถานะ",
          align: "center",
          value: "assistant_teacher_re_status"
        },
        {
          text: "หมายเหตุ",
          align: "center",
          value: "assistant_teacher_re_status_detail"
        },

        { text: "วันเดือนปีบรรจุ", align: "center", value: "mt_date_app_now" },
        { text: "คำสั่งที่", align: "center", value: "mt_order_app" },
        {
          text: "วันที่รายงาน",
          align: "center",
          value: "assistant_teacher_re_datetime"
        },
        {
          text: "ยกเลิกการประเมิน",
          align: "center",
          value: "cancels",
          icon: "mdi-cancel"
        }
      ],
      headers_aassistant_teacher: [
        { text: "ครั้งที่", align: "center", value: "assistant_teacher_times" },
        {
          text: "สถานศึกษา",
          align: "left",
          value: "user_firstname"
        },
        {
          text: "รหัสบัตรประชาชน",
          align: "left",
          value: "assistant_teacher_id_card"
        },
        {
          text: "ชื่อ-นามสกุล",
          align: "left",
          value: "frist_names"
        },
        {
          text: "วันที่ประเมิน",
          align: "center",
          value: "assistant_teacher_datetime"
        },
        { text: "คะแนน", align: "center", value: "assistant_teacher_score" },
        { text: "สถานะ", align: "center", value: "assistant_teacher_status" },
        { text: "ไฟล์แนบ", align: "center", value: "assistant_teacher_file" },
        {
          text: "รายงาน",
          align: "center",
          value: "assistant_teacher_comment"
        },

        {
          text: "สอศ.ตรวจสอบ",
          align: "center",
          value: "assistant_teacher_ipacheck"
        }
      ],
      rang_names: [
        { text: "ชำนาญการ", value: "ชำนาญการ" },
        { text: "ชำนาญการพิเศษ", value: "ชำนาญการพิเศษ" },
        { text: "เชี่ยวชาญ", value: "เชี่ยวชาญ" },
        { text: "เชี่ยวชาญพิเศษ", value: "เชี่ยวชาญพิเศษ" }
      ],
      rang_levels: ["-", 1, 2, 3, 4, 5],
      rowsperpage: [
        25,
        50,
        100,
        {
          text: "All",
          value: -1
        }
      ],
      select_per: "",
      select_personel: [
        { text: "ประเมินครั้งที่ 1 ", value: "1" },
        { text: "ประเมินครั้งที่ 2 ", value: "2" },
        { text: "ประเมินครั้งที่ 3 ", value: "3" },
        { text: "ประเมินครั้งที่ 4 ", value: "4" }
      ],
      college: {},
      provinces: [],
      prefectures: [],
      userstatus: [],
      man_powers: [],
      collgegs: [],
      assistant_teacher_reportstatus: [],
      regions: [],
      region_ena: true,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      assistant_teacher_report_id_card: [],
      assistant_teachers: [],
      addassistant_teacher: {},
      assistant_teachers_edit: {},
      assistant_teachers_confrim: {},
      assistant_teacher_report_s: {},
      result_assistant_teacher_reports: {},
      cancel_assistant_teacher_reports: {},
      cancel_assistant_teachers: {},
      data_syslog: {},
      colleges: [],
      college_select: "",
      Updateassistant_teacher_report: {},
      groupDateTimeApps: [],
      dateTimeAppSelect: null,
      pdflicenseteachdialog: false,
      pt_licence_files: "",
      check_param_query: [],
      check_CC: [],
      assistant_teacher_re_leaveguarantee: "",
      assistant_teacher_re_leaveguaranteedialog: false,
      editmanage_assistant_teacher: [],
      cancel_Licensefiledialog: false,
      user_id: [],
      // New data for charts and statistics
      chartOptions: {},
      statisticsCards: [
        {
          label: "ครูผู้ช่วยทั้งหมด",
          value: 0,
          icon: "mdi-account-group",
          color: "stat-card-blue",
          iconColor: "white"
        },
        {
          label: "พร้อมอนุมัติ คศ.1",
          value: 0,
          icon: "mdi-check-circle",
          color: "stat-card-green",
          iconColor: "white"
        },
        {
          label: "ยังไม่ผ่านเงื่อนไข คศ.1",
          value: 0,
          icon: "mdi-clock-outline",
          color: "stat-card-orange",
          iconColor: "white"
        },
        {
          label: "สรุปวันลาถูกยกเลิก",
          value: 0,
          icon: "mdi-alert-circle",
          color: "stat-card-red",
          iconColor: "white"
        }
      ],

      importCsvDialog: false,
      csvFile: null,
      csvLoading: false,
      csvOrderNo: "",

      // อนุมัติ คศ.1 — สถานะจาก assistant_teacher_level1.php (กติกาเดียวกับตอนอนุมัติจริง)
      atl1Map: {},
      atl1Loading: false,
      atl1RequestSeq: 0,
      atl1Filter: "all",
      atl1CheckFilter: null,
      atl1CheckDefs: [
        {
          key: "eval",
          label: "ผลประเมิน 4 ครั้ง",
          icon: "mdi-clipboard-check-multiple",
          hint: "ผลประเมินครั้งที่ 1-4 ผ่านเกณฑ์ทุกครั้ง และ สอศ. ตรวจสอบแล้ว"
        },
        {
          key: "report",
          label: "สรุปผล/วันลา",
          icon: "mdi-file-document-check",
          hint: "สถานศึกษาส่งสรุปผลการประเมินและหนังสือรับรองวันลา และไม่ถูกยกเลิก"
        },
        {
          key: "license",
          label: "ใบอนุญาตประกอบวิชาชีพ",
          icon: "mdi-card-account-details-star",
          hint: "ปรากฏใบอนุญาตประกอบวิชาชีพครู (ตรวจพบในคุรุสภา หรือ สอศ. ตรวจไฟล์ผ่าน) และยังไม่หมดอายุ ใบอนุญาตปฏิบัติการสอนชั่วคราวไม่นับ"
        },
        {
          key: "tenure",
          label: "ครบ 2 ปี",
          icon: "mdi-calendar-check",
          hint: "ครบ 2 ปีนับจากวันบรรจุ และวันที่มีผลไม่ก่อนวันครบ 2 ปี"
        },
        {
          key: "person",
          label: "ข้อมูลบุคคล",
          icon: "mdi-account-alert",
          hint: "พบข้อมูลในทะเบียนบุคลากร และไม่มีรายชื่อซ้ำในบัญชีครูผู้ช่วย"
        }
      ],
      selected: [],
      approveDialog: false,
      approving: false,
      approveForm: {
        mode: "auto",
        effective_date: "",
        order_no: "",
        order_date: "",
        confirm: false
      },
      resultDialog: false,
      approveResult: null,
      eligibilityDialog: false,
      eligibilityItem: null,
      historyDialog: false,
      historyLoading: false,
      historyRows: [],
      historySearch: "",
      historyMessage: "",
      historyHeaders: [
        { text: "วันที่บันทึก", value: "created_at" },
        { text: "รหัสบัตร", value: "id_card" },
        { text: "ชื่อ-นามสกุล", value: "full_name" },
        { text: "สถานศึกษา", value: "college_name" },
        { text: "วันบรรจุ", value: "appoint_date" },
        { text: "วันที่มีผล", value: "effective_date" },
        { text: "คะแนน", value: "avg_score", align: "center" },
        { text: "คำสั่ง", value: "order_no" },
        { text: "ช่องทาง", value: "source", align: "center" },
        { text: "ผู้อนุมัติ", value: "approved_by" },
        { text: "รหัสชุด", value: "batch_id" }
      ],
      helpDialog: false
    };
  },
  async mounted() {
    await this.userQueryID();
    await this.groupDateTimeAppQuery();
    await this.checkappoint();
    this.$nextTick(() => {
      this.initializeCharts();
    });

    let result;
    result = await this.$http.post("college.php", {
      ApiKey: this.ApiKey
    });
    this.colleges = result.data;
    let user_status_result;
    user_status_result = await this.$http.post(
      "crud_user_status.php?crud=read",
      {
        ApiKey: this.ApiKey
      }
    );
    this.userstatus = user_status_result.data;
  },
  methods: {
    // ---------- อนุมัติ คศ.1 ----------
    async loadEligibility() {
      const list = Array.isArray(this.assistant_teacher_reports)
        ? this.assistant_teacher_reports
        : [];
      const ids = [...new Set(list.map(r => r.mt_id_card).filter(Boolean))];
      const seq = ++this.atl1RequestSeq;
      if (ids.length === 0) {
        this.atl1Map = {};
        return;
      }
      this.atl1Loading = true;
      try {
        const result = await this.$http.post(
          "assistant_teacher_level1.php?action=candidates",
          { ApiKey: this.ApiKey, id_cards: ids }
        );
        if (seq !== this.atl1RequestSeq) return; // มีคำขอใหม่กว่าแล้ว
        const map = {};
        ((result.data && result.data.rows) || []).forEach(r => {
          map[r.id_card] = r;
        });
        this.atl1Map = map;
      } catch (e) {
        if (seq === this.atl1RequestSeq) this.atl1Map = {};
      } finally {
        if (seq === this.atl1RequestSeq) this.atl1Loading = false;
      }
    },
    toggleCheckFilter(key) {
      this.atl1CheckFilter = this.atl1CheckFilter === key ? null : key;
      if (this.atl1CheckFilter) this.atl1Filter = "blocked";
    },
    selectAllEligible() {
      const keys = new Set(this.selected.map(r => r.atl1Key));
      this.selected = this.selected.concat(
        this.eligibleInView.filter(r => !keys.has(r.atl1Key))
      );
    },
    showEligibility(item) {
      this.eligibilityItem = item.atl1;
      this.eligibilityDialog = true;
    },
    openApproveDialog() {
      if (this.selectedRows.length === 0) return;
      this.approveForm = {
        mode: "auto",
        effective_date: "",
        order_no: "",
        order_date: "",
        confirm: false
      };
      this.approveDialog = true;
    },
    async submitApprove() {
      if (
        this.approveForm.mode === "fixed" &&
        !this.$refs.approveForm.validate()
      )
        return;
      await this.sendApprove(
        this.selectedRows.map(r => ({ id_card: r.id_card })),
        {
          mode: this.approveForm.mode,
          effective_date: this.approveForm.effective_date,
          order_no: this.approveForm.order_no,
          order_date: this.approveForm.order_date,
          source: "table"
        }
      );
      this.approveDialog = false;
    },
    // ส่งอนุมัติ (ใช้ทั้งจากตารางและ CSV) — เซิร์ฟเวอร์ตรวจเงื่อนไขซ้ำทุกราย
    async sendApprove(items, opts) {
      this.approving = true;
      try {
        const result = await this.$http.post(
          "assistant_teacher_level1.php?action=approve",
          Object.assign({ ApiKey: this.ApiKey, items }, opts)
        );
        this.approveResult = Object.assign(
          { approved: [], rejected: [], message: "" },
          result.data
        );
        this.resultDialog = true;
        if (this.approveResult.approved.length > 0) {
          this.selected = [];
          await this.checkappoint();
        }
      } catch (error) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาดในการเชื่อมต่อ API" });
      } finally {
        this.approving = false;
      }
    },
    readFileText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = ev => resolve(ev.target.result);
        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    async processCSV() {
      if (!this.csvFile) {
        Swal.fire({ icon: "warning", title: "กรุณาเลือกไฟล์ CSV", timer: 1500 });
        return;
      }
      this.csvLoading = true;
      try {
        const text = await this.readFileText(this.csvFile);
        const items = [];
        let skipped = 0;
        text
          .replace(/^﻿/, "")
          .split(/\r?\n/)
          .filter(row => row.trim() !== "")
          .forEach(row => {
            const cols = row.split(",").map(c => c.trim().replace(/"/g, ""));
            const id = (cols[0] || "").replace(/\D/g, "");
            if (id.length !== 13) {
              skipped++; // แถวหัวตาราง/แถวที่รหัสบัตรไม่ครบ
              return;
            }
            items.push({ id_card: id, effective_date: cols[1] || "" });
          });
        if (items.length === 0) {
          Swal.fire(
            "ข้อผิดพลาด",
            "ไม่พบรหัสบัตรประชาชน 13 หลักในคอลัมน์แรก",
            "error"
          );
          return;
        }
        const confirm = await Swal.fire({
          icon: "question",
          title: `ตรวจสอบและอนุมัติ ${items.length} ราย`,
          text:
            (skipped ? `ข้าม ${skipped} แถวที่ไม่ใช่รหัสบัตร 13 หลัก · ` : "") +
            "รายที่ไม่ผ่านเงื่อนไขจะไม่ถูกอนุมัติ",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        });
        if (!confirm.isConfirmed) return;
        await this.sendApprove(items, {
          mode: "auto",
          order_no: this.csvOrderNo,
          source: "csv"
        });
        this.importCsvDialog = false;
        this.csvFile = null;
        this.csvOrderNo = "";
      } finally {
        this.csvLoading = false;
      }
    },
    downloadCsvTemplate() {
      const lines = ["id_card,effective_date"].concat(
        this.selectedRows.map(r => `${r.id_card},${r.completion_date || ""}`)
      );
      this.downloadText(lines.join("\r\n"), "template_approve_level1.csv");
    },
    exportEligibilityCsv() {
      const esc = v => {
        const s = v == null ? "" : String(v);
        return /[",\r\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
      };
      const roundText = { P: "ผ่าน", W: "รอตรวจ", F: "ไม่ผ่าน", "-": "ยังไม่ส่ง" };
      const head = [
        "ลำดับ",
        "รหัสบัตรประชาชน",
        "ชื่อ-นามสกุล",
        "สถานศึกษา",
        "วันบรรจุ",
        "วันครบ 2 ปี",
        "คะแนนเฉลี่ย",
        "เลขที่ใบอนุญาต",
        "ใบอนุญาตหมดอายุ",
        "ครั้งที่ 1",
        "ครั้งที่ 2",
        "ครั้งที่ 3",
        "ครั้งที่ 4",
        "สถานะ",
        "เหตุผล"
      ];
      const rows = this.tableItems
        .filter(r => r.atl1)
        .map((r, i) => {
          const a = r.atl1;
          return [
            i + 1,
            "\t" + a.id_card, // กัน Excel แปลงเป็นเลขยกกำลัง
            a.full_name,
            a.college_name,
            this.thaiDate(a.appoint_date),
            this.thaiDate(a.completion_date),
            a.avg_score,
            a.licence_no,
            this.thaiDate(a.licence_enddate)
          ]
            .concat(a.rounds.split("").map(c => roundText[c] || c))
            .concat([
              a.eligible ? "พร้อมอนุมัติ" : "ไม่ผ่านเงื่อนไข",
              a.reasons.join(" / ")
            ]);
        });
      if (rows.length === 0) {
        Swal.fire({ icon: "info", title: "ไม่มีรายชื่อให้ส่งออก", timer: 1500 });
        return;
      }
      const csv = [head]
        .concat(rows)
        .map(r => r.map(esc).join(","))
        .join("\r\n");
      this.downloadText(
        csv,
        "assistant_teacher_level1_" +
          new Date().toISOString().substr(0, 10) +
          ".csv"
      );
    },
    downloadText(text, filename) {
      const blob = new Blob(["﻿" + text], {
        type: "text/csv;charset=utf-8"
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    async openHistory() {
      this.historyDialog = true;
      this.historyLoading = true;
      this.historyMessage = "";
      try {
        const result = await this.$http.post(
          "assistant_teacher_level1.php?action=history",
          { ApiKey: this.ApiKey }
        );
        this.historyRows = (result.data && result.data.rows) || [];
        if (result.data && result.data.status === false)
          this.historyMessage = result.data.message;
      } catch (e) {
        this.historyMessage = "โหลดประวัติไม่สำเร็จ";
      } finally {
        this.historyLoading = false;
      }
    },
    thaiDate(ymd) {
      if (!ymd) return "-";
      const m = String(ymd).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!m) return ymd;
      const months = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
      ];
      return (
        parseInt(m[3], 10) +
        " " +
        months[parseInt(m[2], 10) - 1] +
        " " +
        (parseInt(m[1], 10) + 543)
      );
    },

    initializeCharts() {
      try {
        this.loading = true;
        this.updateStatistics();
      } finally {
        this.loading = false;
      }
    },

    updateStatistics() {
      const data = Array.isArray(this.assistant_teacher_reports)
        ? this.assistant_teacher_reports
        : [];
      this.statisticsCards[0].value = data.length;
      this.statisticsCards[1].value = this.atl1Counts.eligible;
      this.statisticsCards[2].value = this.atl1Counts.blocked;
      this.statisticsCards[3].value = data.filter(
        item => item.assistant_teacher_re_status == "CC"
      ).length;
    },

    getPersonnelTypeColor(type) {
      switch (type) {
        case "local_dev":
          return "info";
        case "transfer_position":
          return "warning";
        default:
          return "success";
      }
    },

    getPersonnelTypeText(type) {
      switch (type) {
        case "local_dev":
          return "ครูพัฒนาท้องถิ่น";
        case "transfer_position":
          return "ครูโอนย้าย";
        default:
          return "ปกติ";
      }
    },

    getEvaluationStatusColor(item) {
      if (item.report_id_card === item.id_card) return "green";
      if (["1", "2", "3", "4"].includes(item.last_time_ass)) return "info";
      return "red";
    },

    getEvaluationStatusText(item) {
      if (item.report_id_card === item.id_card) return "ส่งผลการประเมิน";
      if (["1", "2", "3", "4"].includes(item.last_time_ass))
        return `ครั้งที่ ${item.last_time_ass}`;
      return "ไม่ได้เริ่มประเมิน";
    },
    async assistant_teacher_reportSubmit() {
      let textAlert = this.assistant_teacher_report_id_card.frist_names;
      Swal.fire({
        title: "ต้องการยกเลิกรายการนี้",
        text: textAlert,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.assistant_teacher_report_id_card.ApiKey = this.ApiKey;
          let result = await this.$http.post(
            "assistant_teacher_report.delete.php",
            this.assistant_teacher_report_id_card
          );
          if (result.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },
    async cancel_LicensefiledialogSubmit() {
      if (this.$refs.cancel_Licensefiledialogform.validate()) {
        let textAlert =
          this.editmanage_assistant_teacher.mt_title_s +
          this.editmanage_assistant_teacher.mt_frist_name +
          " " +
          this.editmanage_assistant_teacher.mt_last_name;
        Swal.fire({
          title: "การตรวจสอบ",
          text: textAlert,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b3151b",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        }).then(async result => {
          if (result.isConfirmed) {
            this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
            if (
              this.editmanage_assistant_teacher.pt_licence_file_ipa ==
              "dontpass"
            ) {
              let result_del = await this.$http.post("deletefile.php", {
                ApiKey: this.ApiKey,
                filename:
                  "../HRvecLicenseTeach/" +
                  this.editmanage_assistant_teacher.pt_licence_file
              });

              this.editmanage_assistant_teacher.pt_licence_file = "";
            }

            let result = await this.$http.post(
              "manage_assistant_teacher.update.php",
              this.editmanage_assistant_teacher
            );

            if (result.data.status == true) {
              this.manage_assistant_teacher = result.data;
              Swal.fire({
                icon: "success",
                title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
                showConfirmButton: false,
                timer: 1500
              });

              await this.checkappoint();
            } else {
              Swal.fire({
                icon: "warning",
                title: "ดำเนินการผิดพลาด",
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        });
        this.cancel_Licensefiledialog = false;
      }
    },

    async userQueryID() {
      let result;
      let userSession = JSON.parse(localStorage.getItem("user")) || 0;
      result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user_id = result.data;
    },

    async userLogin(user_name, user_password) {
      let result = await this.$http.post("login.php?crud=admin", {
        user_name: user_name,
        user_password: user_password
      });
      if (result.data.user_status) {
        let user = result.data;
        user.system_lock = false;
        localStorage.setItem("user", JSON.stringify(user));
        if (user.user_status == "A") {
          localStorage.setItem("user", JSON.stringify(user));
          this.$router.push("/admin");
        }
        //administrator IPA2
        else if (user.user_status == "B") {
          localStorage.setItem("user", JSON.stringify(user));
          this.$router.push("/college");
        } //college
        else if (user.user_status == "C") this.$router.push("/iven");
        else if (user.user_status == "S") this.$router.push("/supervisions");
        //Vocational Education Institution
        else if (user.user_status == "D") this.$router.push("/personnel");
        //College personnel
        else if (user.user_status == "G") {
          localStorage.setItem("user", JSON.stringify(user));
          this.$router.push("/vecprovince");
        }
        //Vocation College Province
        else {
          localStorage.clear();
          this.dialog = true;
          this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
        }
      }
    },

    async updateLicense(mt_id) {
      this.editmanage_assistant_teacher = [];
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = result.data;
      this.cancel_Licensefiledialog = true;
    },

    async viewFileleavegurantee(assistant_teacher_re_leaveguarantee) {
      this.assistant_teacher_re_leaveguarantee = assistant_teacher_re_leaveguarantee;
      this.assistant_teacher_re_leaveguaranteedialog = true;
    },
    async ccSearch() {
      this.loading = true;
      let result = await this.$http
        .post("manage_assistant_teacher.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_re_status: "CC"
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async viewFileScore(param) {
      this.assFileScore = param;
      this.scoredialog = true;
    },
    async viewpdflicenseteach(pt_licence_file) {
      this.pt_licence_files = pt_licence_file;
      let pt_licence_fileCk = String(pt_licence_file);
      if (pt_licence_fileCk.length > 4) {
        this.pdflicenseteachdialog = true;
      } else {
        Swal.fire({
          icon: "warning",
          title: "ไม่ได้แนบไฟล์",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async checkappoint() {
      this.loading = true;
      let mt_appoin_day = this.mt_appoin_day || 0;
      let mt_appoin_month = this.mt_appoin_month || 0;
      let mt_appoin_year = this.mt_appoin_year || 0;
      let dates = new Date(
        mt_appoin_year + "-" + mt_appoin_month + "-" + mt_appoin_day
      );
      let getTime = dates.getTime();
      this.check_param_query = getTime;
      if (getTime > 1) {
        let result = await this.$http
          .post("manage_assistant_teacher.score.php", {
            ApiKey: this.ApiKey,
            mt_appoin_day: mt_appoin_day,
            mt_appoin_month: mt_appoin_month,
            mt_appoin_year: mt_appoin_year,
            mt_type_personnel: this.mt_type_personnel,
            mt_admissions_status: this.mt_admissions_status,
            mt_report_status_4: "ok"
          })
          .finally(() => (this.loading = false));
        this.assistant_teacher_reports = result.data;
        let data = result.data;
        let counts = 0;
        data.forEach(value => {
          if (value.assistant_teacher_re_status == "CC") {
            counts += 1;
          }
        });
        this.check_CC.counts = counts;
      } else {
        let result = await this.$http
          .post("assistant_teacher_report.php", {
            ApiKey: this.ApiKey
          })
          .finally(() => (this.loading = false));
        this.assistant_teacher_reports = result.data;
      }
    },

    async clearSearch() {
      this.assistant_teacher_reports = [];
    },
    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },
    async search_idcard() {
      await this.sweetAlertLoading();
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_re_id_card: this.search
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
      Swal.close();
    },
    async search_name() {
      await this.sweetAlertLoading();
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          mt_frist_name: this.search
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
      Swal.close();
    },
    async search_lastname() {
      await this.sweetAlertLoading();
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          mt_last_name: this.search
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
      Swal.close();
    },
    async personnel_temporaryDateApp() {
      await this.sweetAlertLoading();
      let dateTimeApp = this.dateTimeAppSelect.split("-");
      let mt_appoin_day = dateTimeApp[0];
      let mt_appoin_month = dateTimeApp[1];
      let mt_appoin_year = dateTimeApp[2];
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          mt_appoin_day: mt_appoin_day,
          mt_appoin_month: mt_appoin_month,
          mt_appoin_year: mt_appoin_year
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
      Swal.close();
    },
    async groupDateTimeAppQuery() {
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        calendar_admin: "Ok"
      });
      this.groupDateTimeApps = result.data;
    },
    async pertem_assistantFileCCSubmit() {
      this.Updateassistant_teacher_report.ApiKey = this.ApiKey;
      this.Updateassistant_teacher_report.id_card = this.editassistant_teacher_report.id_card;
      this.Updateassistant_teacher_report.pertem_assistantFileCC = "";
      let resultPic = await this.$http.post("deletefile.php", {
        ApiKey: this.ApiKey,
        filename:
          "../HRvecfiles/" +
          this.editassistant_teacher_report.pertem_assistantFile
      });
      this.Updateassistant_teacher_report.assistant_teacher_report_pic = "";
      let result = await this.$http.post(
        "assistant_teacher_report.update.php",
        this.Updateassistant_teacher_report
      );
      if (result.data.status == true && resultPic.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.assistant_teacher_reportASCCQueryAll();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.pertem_assistantFileCCdialog = false;
    },
    async pertem_assistantFileCC(mt_id_card) {
      let result = await this.$http.post("assistant_teacher_report.php", {
        ApiKey: this.ApiKey,
        id_card: mt_id_card
      });
      this.editassistant_teacher_report = result.data;
      this.pertem_assistantFileCCdialog = true;
    },
    async cancel_assistant_teacher_report() {
      this.cancel_assistant_teacher_reportdialog = true;
    },
    async evaluate_assistant(mt_id_card) {
      let result = await this.$http.post("assistant_teacher_report.php", {
        ApiKey: this.ApiKey,
        assistant_teacher_re_id_card: mt_id_card
      });
      this.assistant_teacher_report_id_card = result.data;

      let result_assistant = await this.$http.post("assistant_teacher.php", {
        ApiKey: this.ApiKey,
        assistant_teacher_id_card: mt_id_card
      });
      this.assistant_teachers = result_assistant.data;

      this.evaluate_assistantdialog = true;
    },

    async assistant_teacher_selectsearch() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          position_name: "ครูผู้ช่วย",
          last_time_check: this.select_per
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacher_success() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          position_name: "ครูผู้ช่วย",
          evalution_succ: "success"
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacher_reportASCCQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          position_name: "ครูผู้ช่วย",
          pertem_assistantFileCC: "CC"
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacher_not_evalution() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          position_name: "ครูผู้ช่วย",
          not_evalution: "check"
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacher_add() {
      this.addassistant_teacher = {};
      this.assistant_teacherdialog = true;
    },
    async assistant_teacherEdit(assistant_teacher_id) {
      let result_assistant = await this.$http.post("assistant_teacher.php", {
        ApiKey: this.ApiKey,
        assistant_teacher_id: assistant_teacher_id
      });
      this.assistant_teachers_edit = result_assistant.data;
      this.assistant_teacherEditdialog = true;
    },

    async assistant_teacher_reportCollegeQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_re_college_code: this.college_select
        })
        .finally(() => (this.loading = false));
      this.assistant_teacher_reports = result.data;
    },
    async assistant_teacherdialogSubmit() {
      if (this.$refs.assistant_teacherdialogform.validate()) {
        this.addassistant_teacher.ApiKey = this.ApiKey;
        this.addassistant_teacher.assistant_teacher_college_code = this.assistant_teacher_report_id_card.college_code;
        this.addassistant_teacher.assistant_teacher_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
        this.addassistant_teacher.assistant_teacher_times = this.times_s;

        let result = await this.$http.post(
          "assistant_teacher.insert.php",
          this.addassistant_teacher
        );
        if (result.data.status == true) {
          let result = await this.$http.post("assistant_teacher_report.php", {
            ApiKey: this.ApiKey,
            id_card: this.assistant_teacher_report_id_card
              .assistant_teacher_re_id_card
          });
          this.assistant_teacher_report_id_card = result.data;
          let result_assistant = await this.$http.post(
            "assistant_teacher.php",
            {
              ApiKey: this.ApiKey,
              assistant_teacher_id_card: this.assistant_teacher_report_id_card
                .id_card
            }
          );
          this.assistant_teachers = result_assistant.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          this.data_syslog.ApiKey = this.ApiKey;
          this.data_syslog.user_account = userSession.user_name;
          this.data_syslog.event_log = "update";
          this.data_syslog.page_log = "assistant_teacher";
          this.data_syslog.table_log = "assistant_teacher";
          this.data_syslog.detail_log = this.addassistant_teacher.assistant_teacher_id_card;
          this.data_syslog.date_times = this.date_today_log;
          await this.$http.post("data_syslog.insert.php", this.data_syslog);
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.assistant_teacherdialog = false;
      }
    },
    async assistant_teacherEditdialogSubmit() {
      if (this.$refs.assistant_teacherEditform.validate()) {
        this.assistant_teachers_edit.ApiKey = this.ApiKey;

        let result = await this.$http.post(
          "assistant_teacher.update.php",
          this.assistant_teachers_edit
        );
        if (result.data.status == true) {
          let result = await this.$http.post("assistant_teacher_report.php", {
            ApiKey: this.ApiKey,
            id_card: this.assistant_teacher_report_id_card
              .assistant_teacher_re_id_card
          });
          this.assistant_teacher_report_id_card = result.data;
          let result_assistant = await this.$http.post(
            "assistant_teacher.php",
            {
              ApiKey: this.ApiKey,
              assistant_teacher_id_card: this.assistant_teacher_report_id_card
                .id_card
            }
          );
          this.assistant_teachers = result_assistant.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          this.data_syslog.ApiKey = this.ApiKey;
          this.data_syslog.user_account = userSession.user_name;
          this.data_syslog.event_log = "update";
          this.data_syslog.page_log = "assistant_teacher";
          this.data_syslog.table_log = "assistant_teacher";
          this.data_syslog.detail_log = this.assistant_teachers_edit.assistant_teacher_id_card;
          this.data_syslog.date_times = this.date_today_log;
          await this.$http.post("data_syslog.insert.php", this.data_syslog);
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.assistant_teacherEditdialog = false;
      }
    },
    async evaluate_assistantSubmit() {
      this.assistant_teacherConfirmdialog = true;
    },
    async assistant_teacherConfirmdialogSubmit() {
      this.assistant_teachers_confrim.ApiKey = this.ApiKey;
      this.assistant_teachers_confrim.assistant_teacher_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
      this.assistant_teachers_confrim.assistant_teacher_status = "confirm";
      this.assistant_teacher_report_s.ApiKey = this.ApiKey;
      this.assistant_teacher_report_s.assistant_teacher_re_college_code = this.assistant_teacher_report_id_card.college_code;
      this.assistant_teacher_report_s.assistant_teacher_re_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
      this.assistant_teacher_report_s.assistant_teacher_re_datetime = this.date_today;
      this.assistant_teacher_report_s.assistant_teacher_re_avg_score = this.assistant_teacher_report_id_card.avg_score;

      let result = await this.$http.post(
        "assistant_teacher.update.confirm.php",
        this.assistant_teachers_confrim
      );
      let result_assistant_teacher_report = await this.$http.post(
        "assistant_teacher_report.insert.php",
        this.assistant_teacher_report_s
      );
      if (
        result.data.status == true &&
        result_assistant_teacher_report.data.status == true
      ) {
        let result = await this.$http.post("assistant_teacher_report.php", {
          ApiKey: this.ApiKey,
          id_card: this.assistant_teacher_report_id_card
            .assistant_teacher_re_id_card
        });
        this.assistant_teacher_report_id_card = result.data;
        let result_assistant = await this.$http.post("assistant_teacher.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_id_card: this.assistant_teacher_report_id_card
            .id_card
        });
        let result_assistant_teacher_report = await this.$http.post(
          "assistant_teacher_report.php",
          {
            ApiKey: this.ApiKey,
            assistant_teacher_re_id_card: this.assistant_teacher_report_id_card
              .id_card
          }
        );
        this.result_assistant_teacher_reports =
          result_assistant_teacher_report.data;
        let userSession = JSON.parse(localStorage.getItem("user")) || 0;
        this.data_syslog.ApiKey = this.ApiKey;
        this.data_syslog.user_account = userSession.user_name;
        this.data_syslog.event_log = "insert";
        this.data_syslog.page_log = "assistant_teacher_report";
        this.data_syslog.table_log = "assistant_teacher_report";
        this.data_syslog.detail_log = this.assistant_teacher_report_s.assistant_teacher_re_id_card;
        this.data_syslog.date_times = this.date_today_log;
        await this.$http.post("data_syslog.insert.php", this.data_syslog);
        this.assistant_teachers = result_assistant.data;
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.assistant_teacherConfirmdialog = false;
    },
    // แก้คำสั่ง/วันที่บรรจุครูผู้ช่วย — แถวในตารางมาจาก assistant_teacher_report + manage_assistant_teacher
    // (เดิมส่ง item.id_rc ซึ่งไม่มีในแถว และเรียก endpoint ที่ไม่มีอยู่ จึงแก้ไขไม่ได้มาตลอด)
    assistant_teacher_reportEdit(item) {
      this.editassistant_teacher_report = {
        id_card: item.mt_id_card || item.assistant_teacher_re_id_card,
        college_name: item.college_name || item.user_firstname || "",
        frist_names: item.frist_names,
        date_app: item.mt_date_app_now,
        order_app_now: item.mt_order_app || "",
        date_app_now: String(item.mt_date_app_now || "").substr(0, 10)
      };
      this.editassistant_teacher_reportdialog = true;
    },
    async editassistant_teacher_reportSubmit() {
      if (this.$refs.editassistant_teacher_reportform.validate()) {
        let result = await this.$http.post("assistant_teacher_report.update.admin.php", {
          ApiKey: this.ApiKey,
          id_card: this.editassistant_teacher_report.id_card,
          order_app_now: this.editassistant_teacher_report.order_app_now,
          date_app_now: this.editassistant_teacher_report.date_app_now
        });
        if (result.data.status == true) {
          this.assistant_teacher_report = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          this.data_syslog.ApiKey = this.ApiKey;
          this.data_syslog.user_account = userSession.user_name;
          this.data_syslog.event_log = "update";
          this.data_syslog.page_log = "assistant_teacher";
          this.data_syslog.table_log = "assistant_teacher_report";
          this.data_syslog.detail_log = this.editassistant_teacher_report.id_card;
          this.data_syslog.date_times = this.date_today_log;
          await this.$http.post("data_syslog.insert.php", this.data_syslog);
          this.assistant_teacher_reportQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.editassistant_teacher_reportdialog = false;
      }
    },
    async cancel_assistant_teacher_reportdialogSubmit() {
      await this.sweetAlertLoading();
      this.cancel_assistant_teacher_reports.ApiKey = this.ApiKey;
      this.cancel_assistant_teacher_reports.assistant_teacher_re_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
      this.cancel_assistant_teachers.ApiKey = this.ApiKey;
      this.cancel_assistant_teachers.assistant_teacher_id_card = this.assistant_teacher_report_id_card.assistant_teacher_re_id_card;
      this.cancel_assistant_teachers.assistant_teacher_status = "";
      this.cancel_assistant_teachers.assistant_teacher_ipacheck = "NotPass";

      let result = await this.$http.post(
        "assistant_teacher.update.confirm.php",
        this.cancel_assistant_teachers
      );
      let result_assistant_teacher_report = await this.$http.post(
        "assistant_teacher_report.delete.php",
        this.cancel_assistant_teacher_reports
      );
      if (
        result.data.status == true ||
        result_assistant_teacher_report.data.status == true
      ) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        let userSession = JSON.parse(localStorage.getItem("user")) || 0;
        this.data_syslog.ApiKey = this.ApiKey;
        this.data_syslog.user_account = userSession.user_name;
        this.data_syslog.event_log = "Cancel";
        this.data_syslog.page_log = "assistant_teacher";
        this.data_syslog.table_log = "assistant_teacher_report";
        this.data_syslog.detail_log = this.cancel_assistant_teachers.assistant_teacher_id_card;
        this.data_syslog.date_times = this.date_today_log;
        await this.$http.post("data_syslog.insert.php", this.data_syslog);
        Swal.close();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.evaluate_assistantdialog = false;
      this.cancel_assistant_teacher_reportdialog = false;
      await this.checkappoint();
    },

    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    }
  },
  watch: {
    // ชุดข้อมูลในตารางเปลี่ยน (ค้นหา/กรอง/โหลดใหม่) → ตรวจความพร้อมเฉพาะรายชื่อที่แสดง
    assistant_teacher_reports() {
      this.selected = [];
      this.updateStatistics();
      this.loadEligibility();
    },
    atl1Map() {
      this.updateStatistics();
    }
  },
  computed: {
    // แถวในตาราง + สถานะ คศ.1 (atl1Key ต้องไม่ซ้ำ — แถวที่อนุมัติแล้วจะไม่มี mt_id_card)
    tableItemsAll() {
      const list = Array.isArray(this.assistant_teacher_reports)
        ? this.assistant_teacher_reports
        : [];
      return list.map((r, i) => {
        const atl1 = (r.mt_id_card && this.atl1Map[r.mt_id_card]) || null;
        return Object.assign({}, r, {
          atl1,
          atl1Key: r.mt_id_card || "row-" + (r.assistant_teacher_re_id || i),
          atl1Selectable: !!(atl1 && atl1.eligible)
        });
      });
    },
    tableItems() {
      return this.tableItemsAll.filter(r => {
        if (this.atl1Filter === "eligible" && !r.atl1Selectable) return false;
        if (this.atl1Filter === "blocked" && !(r.atl1 && !r.atl1.eligible))
          return false;
        if (
          this.atl1CheckFilter &&
          !(r.atl1 && r.atl1.failed.includes(this.atl1CheckFilter))
        )
          return false;
        return true;
      });
    },
    atl1Counts() {
      const counts = { eligible: 0, blocked: 0, byCheck: {} };
      this.tableItemsAll.forEach(r => {
        if (!r.atl1) return;
        if (r.atl1.eligible) counts.eligible++;
        else counts.blocked++;
        r.atl1.failed.forEach(k => {
          counts.byCheck[k] = (counts.byCheck[k] || 0) + 1;
        });
      });
      return counts;
    },
    // ผู้พร้อมอนุมัติที่ตรงกับตัวกรองและคำค้นในตารางขณะนี้
    eligibleInView() {
      const q = (this.search || "").toString().toLowerCase().trim();
      return this.tableItems.filter(r => {
        if (!r.atl1Selectable) return false;
        if (!q) return true;
        return this.headers.some(h => {
          const v = r[h.value];
          return v != null && String(v).toLowerCase().includes(q);
        });
      });
    },
    selectedRows() {
      return this.selected.filter(r => r.atl1Selectable).map(r => r.atl1);
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    times_s() {
      let times = this.assistant_teacher_report_id_card.last_time;
      let result;
      if (times == "1") {
        result = 2;
      } else if (times == "2") {
        result = 3;
      } else if (times == "3") {
        result = 4;
      } else if (times == "4") {
        result = "ครบการประเมิน";
      } else {
        result = 1;
      }
      return result;
    },
    date_today() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear() + 543;
      today = dd + "/" + mm + "/" + yyyy;
      return today;
    },
    color() {
      return "primary";
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear() + 543;
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      today = dd + "/" + mm + "/" + yyyy + "/" + time;
      return today;
    },
    mt_appoin_day() {
      return this.$route.query.appoin_day;
    },
    mt_appoin_month() {
      return this.$route.query.appoin_month;
    },
    mt_appoin_year() {
      return this.$route.query.appoin_year;
    },
    mt_admissions_status() {
      return this.$route.query.mt_admissions_status;
    },
    mt_type_personnel() {
      return this.$route.query.mt_type_personnel;
    }
  },
  components: { Assistant_teacher_bar }
};
</script>
<style scoped>
.dashboard-container {
  background: linear-gradient(135deg, #f5f5f5 0%, #90a4ae 100%);
  min-height: 100vh;
}

.dashboard-header {
  background: var(--hv-hero);
  margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.main-content {
  margin-top: -1rem;
}

/* Statistics Cards */
.stat-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  border: none !important;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

.stat-card-blue {
  background: linear-gradient(135deg, #3B82C4 0%, #2B6CB0 100%);
  color: white;
}

.stat-card-green {
  background: linear-gradient(135deg, #d9777b 0%, #f5576c 100%);
  color: white;
}

.stat-card-orange {
  background: linear-gradient(135deg, #90a4ae 0%, #455a64 100%);
  color: white;
}

.stat-card-red {
  background: linear-gradient(135deg, #2e7d32 0%, #2e7d32 100%);
  color: white;
}

.stat-number {
  color: white !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.stat-label {
  color: white !important;
  opacity: 0.9;
}

/* Chart Cards */
.chart-card {
  border-radius: 16px !important;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
  border: none !important;
}

.chart-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e9ecef;
  border-radius: 16px 16px 0 0 !important;
}

/* Filter Card */
.filter-card {
  border-radius: 16px !important;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}

.filter-content {
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef !important;
}

.custom-input {
  background: white;
  border-radius: 8px;
}

.custom-input >>> .v-input__control {
  border-radius: 8px;
}

.custom-btn {
  border-radius: 12px !important;
  font-weight: 500;
  text-transform: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.custom-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Alert */
.alert-custom {
  border-radius: 12px !important;
  background: rgba(255, 193, 7, 0.1) !important;
  border-left: 4px solid #A86400 !important;
}

/* Table Card */
.table-card {
  border-radius: 16px !important;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}

.custom-table {
  border-radius: 0 0 16px 16px;
}

.custom-table >>> .v-data-table__wrapper {
  border-radius: 0 0 16px 16px;
}

.custom-table >>> th {
  background: #f8f9fa !important;
  color: #495057 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #dee2e6 !important;
}

.custom-table >>> td {
  border-bottom: 1px solid #f1f3f4 !important;
  padding: 12px 16px !important;
}

.custom-table >>> tr:hover {
  background: rgba(25, 118, 210, 0.04) !important;
}

/* Search Section */
.search-section {
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
  border-bottom: 1px solid #e9ecef;
}

.search-input {
  background: white;
  border-radius: 8px;
}

.search-input >>> .v-input__control {
  border-radius: 8px;
}

.search-options >>> .v-input--radio-group__input {
  justify-content: center;
}

/* Chips */
.chip-custom {
  border-radius: 12px !important;
  font-weight: 500;
  text-transform: none;
}

.score-chip {
  cursor: pointer;
  border-radius: 12px !important;
  font-weight: 600;
  transition: all 0.2s ease;
}

.score-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
}

.evaluation-chip {
  cursor: pointer;
  border-radius: 12px !important;
  font-weight: 500;
  min-width: 120px;
  transition: all 0.2s ease;
}

.evaluation-chip:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.score-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* อนุมัติ คศ.1 */
.atl1-toolbar {
  border-radius: 12px !important;
  background: #f8f9fa;
}

.atl1-round {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  margin: 0 1px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  color: white;
}

.atl1-round-P {
  background: #2e7d32;
}

.atl1-round-W {
  background: #a86400;
}

.atl1-round-F {
  background: #c62828;
}

.atl1-round-- {
  background: #9e9e9e;
}

.atl1-help h3 {
  margin: 16px 0 8px;
}

/* Cursor */
.cursor-pointer {
  cursor: pointer;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Responsive */
@media (max-width: 960px) {
  .dashboard-header {
    padding: 2rem 1rem;
  }

  .dashboard-header h1 {
    font-size: 1.8rem !important;
  }

  .stat-card {
    margin-bottom: 1rem;
  }

  .filter-content .v-col {
    padding: 8px !important;
  }
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card,
.chart-card,
.filter-card,
.table-card {
  animation: fadeInUp 0.6s ease forwards;
}

.stat-card:nth-child(1) {
  animation-delay: 0.1s;
}
.stat-card:nth-child(2) {
  animation-delay: 0.2s;
}
.stat-card:nth-child(3) {
  animation-delay: 0.3s;
}
.stat-card:nth-child(4) {
  animation-delay: 0.4s;
}
</style>
